/* eslint-disable no-loop-func */
import React, { useState, useEffect, Fragment } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

//*MUI
import { Box, Modal, Popover, Typography } from '@mui/material';

//*redux
import { useDispatch, useSelector } from 'react-redux';
import action from '../../../../Redux Store/actions';

//*files
import cssClasses from './EventPayment.module.css';
import DropDown from '../../../../Subcomponents/DropDown';
import Button from '../../../../Subcomponents/Button';
import Close from '../../../Icons/Close';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

import {
  AddPaymentData,
  getAllInventoryStatusFromTable,
  getAllLeadsForSearch,
  getAllLeadsForSearchName,
  getLeadDetailsForSustenance,
  getLeadDetailsFromInventory,
  getProjectByProjectName,
  getUnitByUnitNo,
  getUnitCancellation,
  RemoveLeadFromInterestQueue,
  UpdateLeadIdToInventory,
} from '../../../../Services/SustenanceService';
import Datagrid from '../../../../Subcomponents/Datagrid';
import ThreeDotsMenu from '../../../../Subcomponents/ThreeDotsMenu';
import {
  checkForInventoryStatus,
  AddPreSelectData,
  AddUnitInterest,
  allotUnit,
  autoAdjustToken,
  AutoReleaseUnits,
  checkEventTokenLeadRelation,
  DeleteTokenTransaction,
  getAllInventoryStatus,
  getAllLeadNameForToken,
  getAllotedLeadFromPaymentsTable,
  getAllotmentPayment,
  getAllotmentPaymentByUnit,
  getAllUnitInterests,
  getEvent,
  getEventByEventName,
  getInventoryStatus,
  getLaunchesByEventId,
  getLeadData,
  getLeadDetails,
  getLeadForToken,
  getLeadFromAllotment,
  getLeadFromMergedAllotment,
  getProjectPricingByUnitId,
  getUnitStatus,
  InsertIntoAllotmentTable,
  updateLeadStatusForAllotment,
  updatePreSelectData,
  UpdateTokenStatus,
  UpdateUnitStatus,
} from '../../../../Services/Event';
import { errorTost, infoTost, successTost } from '../../../../Services/Toast';

import {
  getAlotEventGlobalUnitAvailable,
  getAlotEventGlobalLeadAvailable,
  getAlotEventLead,
} from '../../../../Services/StoredSessionData';
import {
  addLeadLogs,
  updateLeadAllStatus,
  updateLeadStatus,
} from '../../../../Services/Lead';
import {
  getEventTokenLeadRelations,
  getSelectedToken,
  updateEventLeadToken,
  updateEventLeadTokenEvent,
  updateEventLeadTokenGroup,
} from '../../../../Services/AssignNewToken';
import LeadStatusChip from '../../../../Subcomponents/LeadStatusChip';
import Dot from '../../../Icons/Dot';
import { debounce, filter, isNull, set, uniq, uniqBy } from 'lodash';
import axios from 'axios';
import { dismissLoader, presentLoader } from '../../../../Services/loader';
import { supabase } from '../../../../supabaseClient';
import { getLeadsForTokenPaymentDone } from '../../../../Services/Queue';
import DateComponent from '../../../../Subcomponents/DateComponent';
import CameraCapture from '../../../../Subcomponents/CameraCapture';
import {
  insertAllotmentTransactions,
  insertIntoAllotmentTransactions,
  insertInventoryLogs,
  insertTransactionLogs,
  updateAllotmentPayment,
  uploadChequeImage,
} from '../../../../Services/AllAllotments';
import LoaderWithMsg from '../../../../Subcomponents/LoaderWithMsg';
import CustomAutoComplete from '../../../../Subcomponents/CustomAutoComplete';
import PaymentModal from '../../../../Modals/PaymentModal/PaymentModal';
import {
  getAllPaymentPlans,
  getAllPaymentsPlansByLaunch,
  getAllPlansByLaunch,
  getAllPricingPlansByLaunch,
} from '../../../../Services/PaymentPlans';
import { WhatsappIcon } from 'react-share';
import { CheckBookingAmounts, getPaymentPlansPriceFromServer } from '../../../../Services/Project';
import {
  updateAllotmentTransactions,
  updateAllotmentTransactionsForTrnsUpdate,
} from '../../../../Services/ChangeUnit';
import { sendMailTo } from '../../../../Services/SmsService';
import { bucketingForChangeUnit } from '../../../../Services/PaymentApi';
import { getTokenTransactions } from '../../../../Services/Payments';
import { getInventoryTypeId } from '../../../../Services/Inventory';

function EventPayment() {
  let loggedInUser = {};

  loggedInUser = useSelector((state) => state.Auth.user);
  // console.log(loggedInUser);
  const { eventID, projectId, wingName, unitNo, launchId } = useParams();
  const [PaymentDetailsButton, setPaymentDetailsButton] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [loaderMsg, setLoaderMsg] = useState('');
  const [pageMaintain, setPageMaintain] = useState(0);
  const [ProjectData, setProjectData] = useState([]);
  const [event, setEvent] = useState(null);
  const [SelectedLeadDisplayId, setSelectedLeadDisplayId] = useState('');
  const [SelectedLeadName, setSelectedLeadName] = useState('');
  const [PricingDetails, setPricingDetails] = useState([]);
  const [TokenMessage, setTokenMessage] = useState(false);
  const [CheckPt2Message, setCheckPt2Message] = useState(false);
  const [AllotmentIdData, setAllotmentIdData] = useState([]);
  const [openPaymentModal, setOpenPaymentModal] = useState(false);
  const [OnHoldData, setOnHoldData] = useState(false);
  const [OnHoldDetails, setOnHoldDetails] = useState([]);
  const [priceNotAdded, setPriceNotAdded] = useState(false);
  const [afterCancelUnitPrice, setAfterCancelUnitPrice] = useState(false);
  const [PreSelectInfo, setPreSelectInfo] = useState([]);
  const [EventDurationData, setEventDurationData] = useState('');
  const [BookingAmountData, setBookingAmountData] = useState([]);
  const [TotalBsp, setTotalBsp] = useState(null);
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [FloorRiseValue, setFloorRiseValue] = useState(0);
  const [plcValue, setPlcValue] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [balanceAmount, setBalanceAmount] = useState(0);
  const [paidAmount, setPaidAmount] = useState(0);
  const [Unit1Name, setUnit1Name] = useState('');
  const [Unit2Name, setUnit2Name] = useState('');
  const [
    errorMessageForAlotUnitAlreadyAlloted,
    setErrorMessageForAlotUnitAlreadyAlloted,
  ] = useState('');
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const dispatch = useDispatch();
  const steps = [
    {
      title: 'Lead Details',
      text: '',
    },
    {
      title: 'Payment Details',
      text: '',
    },
  ];
  const style = {
    position: 'absolute',
    top: '45%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 'fit-content',
    height: 'fit-content',
    bgcolor: 'background.paper',
    borderRadius: '8px',
    boxShadow: 24,
  };

  const [pageNumber, setPageNumber] = useState(0);
  const [pageSize, setPageSize] = useState(15);
  // const [unitStatus, setUnitStatus] = useState('Put the Unit on Hold');
  const UnitStatusType = ['Put the Unit On Hold'];
  const [ChipStyle, setChipStyle] = useState(null);

  const [SameUser, setSameUser] = useState(false);

  const [LeadData, setLeadData] = useState([]);
  const [UnitData, setUnitData] = useState([]);
  const [allotmentPaymentId, setAllotmentPaymentId] = useState('');
  const [UnitInterestData, setUnitInterestData] = useState([]);
  const [DisabledInterest, setDisabledInterest] = useState(true);
  const [LeadID, setLeadId] = useState('');
  const [globalLead, setGlobalLead] = useState(false);
  const [allotedInventoryStatus, setAllottedInventoryStatus] = useState([]);
  const [kycPendingInventoryStatus, setKycPendingInventoryStatus] = useState(
    []
  );
  const [HoldInventoryStatus, setHoldInventoryStatus] = useState([]);
  const [PreSelectInventoryStatus, setPreSelectInventoryStatus] = useState([]);
  const [ProjectPricingDetails, setProjectPricingDetails] = useState([]);
  const [InterestQueueTable, setInterestQueueTable] = useState(false);
  const [TokenList, setTokenList] = useState([]);
  //*merge-Allotment
  const [mergeIdData, setMergeIdData] = useState(false);
  const [mergeID, setMergeID] = useState('');
  const [Unit1, setUnit1] = useState('');
  const [Unit2, setUnit2] = useState('');

  const [LeadValue, setLeadValue] = useState(null);
  const [LeadName, setLeadName] = useState('');
  const [AllLeads, setAllLeads] = useState([]);
  const [fastBooking, setFastBooking] = useState(false);

  const [PayNowButton, setPayNowButton] = useState(false);

  const [PreSelectedLead, setPreSelectedLead] = useState(false);
  const [PreSelectPayNow, setPreSelectPayNow] = useState(false);

  const [UserSecondVisit, setUserSecondVisit] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  // **Project pricing list
  const [listOfProjectPricing, setListOfProjectPricing] = useState([]);
  const [selectedProjectPricingTitle, setSelectedProjectPricingTitle] =
    useState('');
  let WhatsAppMessage = `Hello! Greetings from Vilas Javdekar Developers. You can visit https://vj-customer-app-testing.web.app/ for your preselect payments!`;
  const [phoneNumber, setPhoneNumber] = useState(null);
  const [csvUploaded, setCsvUploaded] = useState(false);

  // **Project Payment Plan
  const [listOfProjectPaymentPlan, setListOfProjectPaymentPlan] = useState([]);
  const [selectedProjectPaymentPlanId, setSelectedProjectPaymentPlanId] =
    useState('');
  const [selectedProjectPaymentPlan, setSelectedProjectPaymentPlan] =
    useState(null);

  const handleClick = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };
  const IconOpen = Boolean(anchorEl);

  const id = IconOpen ? 'simple-popover' : undefined;
  const handleIconClose = (e) => {
    e.stopPropagation();
    setAnchorEl(null);
  };
  useEffect(() => {
    getInventoryTypeId(unitNo).then((inventoryResp) => {
      getAllPaymentPlans(projectId, wingName, inventoryResp[0].displayUnitType)
        .then((allPaymentPlans) => {
          console.log({ allPaymentPlans });
          setListOfProjectPaymentPlan([{ title: "none" }, ...allPaymentPlans.data,]);
        })
        .catch((err) => {
          console.error(err);
        });
    })
  }, []);

  function checkInBasePriceList(object, byDefault) {
    getUnitByUnitNo(unitNo)
      .then((UnitDetails) => {
        console.log('Unit-Details-checked', UnitDetails.data);
        console.log('object for check', object);
        if (object) {
          let inventoryTypeId =
            UnitDetails.data[0].inventoryTypeId.inventoryTypeId;
          let saleableArea = UnitDetails.data[0].saleableArea;
          setSaleableArea(saleableArea);
          console.log('object', object);
          let pricingToShow = object?.projectPricingId?.basePrices.filter(
            (el) =>
              el.sqft === saleableArea && el.inventoryTypeId === inventoryTypeId
          );
          // **After filtering base Price List
          console.log({ pricingToShow });
          setTotalBsp(pricingToShow[0]);
          console.log(pricingToShow[0]);
        } else {
          setPriceNotAdded(true);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }
  // useEffect(() => {
  //   getLeadFromAllotment(unitNo , LeadID).then((response) => {
  //     console.log("Allotment-table-Data" , response)
  //     if(response.count > 0) {
  //       response.data[0].allotmentpaymentid =
  //     response.data[0].allotmentPaymentId;
  //     setAllotmentIdData(response.data);
  //     }

  //   }).catch((err) => {
  //     console.log("Allotment-table-Data" , err)
  //   })
  // }, [])

  useEffect(() => {
    dispatch(action.activeMenu('eventdirectallotment'));
    getUnitData();
    UnitDetails(false);
    getProjectPriceDetails();
    console.log('------------------------->', AllotmentIdData);
  }, []);

  useEffect(() => {
    defineChipColor();
    console.log('unitNo', unitNo);
  }, [ProjectPricingDetails[0]?.inventoryStatusId?.status]);

  useEffect(() => {
    let data = sessionStorage.getItem('fastBookingType');
    console.log('data--------->', data);
    if (data) {
      setFastBooking(true);
    }
  }, []);

  //*global lead allotment
  useEffect(() => {
    //*routeFromGlobalLeadEvent
    console.log("getAlotEventGlobalLeadAvailable() ==> ", getAlotEventGlobalLeadAvailable())
    if (getAlotEventGlobalLeadAvailable() === true) {
      setGlobalLead(true);
      if (getAlotEventGlobalUnitAvailable() === true) {
        console.info("Saying Alot unit is Available");
        // ! set to false for confirm button
        setPaymentDetailsButton(false);
        setCheckPt2Message(false);
        let lead = getAlotEventLead();
        setLeadId(lead?.leadId);
        let object = {
          LeadName: lead?.leadname,
          LeadDisplayId: lead?.leaddisplayid.replace(
            lead?.leaddisplayid?.substring(8, 12),
            '-' + lead?.leaddisplayid.substring(8, 12)
          ),
          LeadMobileNumber: lead?.leadDetails?.contactNumber,
          LeadEmail: lead?.leadDetails?.leadEmail,
        };
        setLeadData([object]);
        console.log('lead--->', lead);
        console.log("NextStepWithLeadId called 11111");
        NextStepWithLeadId(lead?.leadId);
        setSelectedLeadName(lead?.leadname);
        setSelectedLeadDisplayId(
          lead?.leaddisplayid.replace(
            lead?.leaddisplayid?.substring(8, 12),
            '-' + lead?.leaddisplayid.substring(8, 12)
          )
        );
        setTokenData((pre) => {
          pre.token = lead?.paymentId;
          return { ...pre };
        });
      } else {
        console.info('Saying Alot unit is Hold');
        let lead = getAlotEventLead();
        setLeadId(lead?.leadId);
        let object = {
          LeadName: lead?.leadname,
          LeadDisplayId: lead?.leaddisplayid.replace(
            lead?.leaddisplayid?.substring(8, 12),
            '-' + lead?.leaddisplayid.substring(8, 12)
          ),
          LeadMobileNumber: lead?.leadDetails?.contactNumber,
          LeadEmail: lead?.leadDetails?.leadEmail,
        };
        console.info(lead?.leadId);
        setLeadData([object]);
        console.log('lead--->', lead);
        console.log("NextStepWithLeadId called 22222");

        NextStepWithLeadId(lead?.leadId);
        setSelectedLeadName(lead?.leadname);
        setSelectedLeadDisplayId(
          lead?.leaddisplayid.replace(
            lead?.leaddisplayid?.substring(8, 12),
            '-' + lead?.leaddisplayid.substring(8, 12)
          )
        );
        setTokenData((pre) => {
          pre.token = lead?.paymentId;
          return { ...pre };
        });
      }
    }
  }, []);

  //*snapShot
  useEffect(() => {
    let updateUnitListener = supabase
      .from('Inventory')
      .on('UPDATE', (handleRecordUpdated) => {
        console.log(handleRecordUpdated);
        if (handleRecordUpdated.eventType === 'UPDATE') {
          getUnitData();
        }
      })
      .subscribe((status) => {
        console.log('status: ', status);
      });
    return () => {
      if (updateUnitListener) {
        supabase.removeSubscription(updateUnitListener);
        updateUnitListener = null;
      }
    };
  }, []);
  // // !!Alot Unit from Payments Tab Pending Payments
  // useEffect(() => {
  //   if (getAlotEventLead()?.oldAllotmentData) {
  //     if (mergeIdData) {
  //       if (csvUploaded) {
  //         if (
  //           parseFloat(TotalBsp?.totalCost) +
  //             parseFloat(TotalBsp?.totalCost) +
  //             parseFloat(FloorRiseValue) +
  //             parseFloat(plcValue) -
  //             getAlotEventLead()?.oldAllotmentData.paidamount <
  //           0
  //         ) {
  //           setErrorMessageForAlotUnitAlreadyAlloted(
  //             "New booking amount is less than the booking amount paid"
  //           );
  //         } else {
  //           setErrorMessageForAlotUnitAlreadyAlloted("");
  //         }
  //       } else {
  //         if (
  //           parseFloat(TotalBsp?.Total) +
  //             parseFloat(TotalBsp?.Total) +
  //             parseFloat(FloorRiseValue) +
  //             parseFloat(plcValue) -
  //             getAlotEventLead()?.oldAllotmentData.paidamount <
  //           0
  //         ) {
  //           setErrorMessageForAlotUnitAlreadyAlloted(
  //             "New booking amount is less than the booking amount paid"
  //           );
  //         } else {
  //           setErrorMessageForAlotUnitAlreadyAlloted("");
  //         }
  //       }
  //     } else {
  //       // !!Not merged
  //       if (csvUploaded) {
  //         if (
  //           parseFloat(TotalBsp?.totalCost) +
  //             parseFloat(FloorRiseValue) +
  //             parseFloat(plcValue) -
  //             getAlotEventLead()?.oldAllotmentData.paidamount <
  //           0
  //         ) {
  //           setErrorMessageForAlotUnitAlreadyAlloted(
  //             "New booking amount is less than the booking amount paid"
  //           );
  //         } else {
  //           setErrorMessageForAlotUnitAlreadyAlloted("");
  //         }
  //       } else {
  //         if (
  //           parseFloat(TotalBsp?.Total) +
  //             parseFloat(FloorRiseValue) +
  //             parseFloat(plcValue) -
  //             getAlotEventLead()?.oldAllotmentData.paidamount <
  //           0
  //         ) {
  //           setErrorMessageForAlotUnitAlreadyAlloted(
  //             "New booking amount is less than the booking amount paid"
  //           );
  //         } else {
  //           setErrorMessageForAlotUnitAlreadyAlloted("");
  //         }
  //       }
  //     }
  //   }
  // }, [FloorRiseValue, TotalBsp, csvUploaded, mergeIdData, plcValue]);

  const [AllotmentData, setAllotmentData] = useState({
    displayName: '',
  });

  const [helperText, setHelperText] = useState({
    displayName: '',
  });

  const [TokenData, setTokenData] = useState({
    token: '',
  });

  const [TokenHelperText, setTokenHelperText] = useState({
    token: '',
  });
  const [saleableArea, setSaleableArea] = useState('');
  //*Display-of-UnitInterest-Table
  function getUnitData() {
    getUnitByUnitNo(unitNo)
      .then((resp) => {
        // console.info('Unit-Details', resp.data);
        // console.log(
        //   'resp.data[0].inventoryMergeId',
        //   resp.data[0].inventoryMergeId
        // );
        // console.log('resp.data[0].unitId', resp.data[0].unitId);
        setUnitData(resp.data);
        getAllotmentPaymentByUnit(
          resp.data[0].inventoryMergeId?.inventoryMergeId,
          resp.data[0].unitId
        )
          .then((allotmentPaymentRes) => {
            // console.log('Allotment-Payment', allotmentPaymentRes);
            if (allotmentPaymentRes.count > 0) {
              allotmentPaymentRes.data[0].allotmentpaymentid =
                allotmentPaymentRes.data[0].allotmentPaymentId;
              setAllotmentIdData(allotmentPaymentRes.data);
              if (resp.data[0]?.leadId?.leadId) {
                // ! vedashree changes => if leadId in allotment === current selectedLead.leadId, then show 'share payment details' button;
                // ! else do not show any button
                let preselectedForLead = JSON.parse(
                  sessionStorage.getItem('GlobalLeadPreSelectedLeadData')
                );
                if (
                  resp.data[0]?.leadId?.leadId === preselectedForLead?.leadId
                ) {
                  setPhoneNumber(resp.data[0]?.leadId?.personId?.contactNumber);
                  WhatsAppMessage = `Hello ${resp.data[0]?.leadId?.personId?.name}, Greetings from Vilas Javdekar Developers. You can visit https://vj-customer-app-testing.web.app/ for your preselect payments!`;
                  setPreSelectPayNow(true);
                } else {
                  setPreSelectPayNow(null);
                }
              }
            }
          })
          .catch((err) => {
            console.error('allotmentPaymentRes', err);
          });
        if (resp.data[0]?.inventoryMergeId) {
          setMergeIdData(true);
          setMergeID(resp.data[0].inventoryMergeId.inventoryMergeId);
          setUnit1Name(resp.data[0].inventoryMergeId.unit1No);
          setUnit2Name(resp.data[0].inventoryMergeId.unit2No);
          setUnit1(resp.data[0].inventoryMergeId.unit1Id);
          setUnit2(resp.data[0].inventoryMergeId.unit2Id);
        }
        getEvent(eventID)
          .then((eventRes) => {
            setEvent(eventRes[0]);
          })
          .catch((err) => {
            console.error('eventRes', err);
          });
        // ! to check useCsv flag
        getProjectPricingByUnitId(wingName, projectId)
          .then((inventory) => {
            // console.log('Project-Pricing-data', inventory);
            // console.log('Pricing-data', resp.data);
            inventory.data[0]?.basePrices?.forEach((_Item) => {
              // console.log(
              //   'resp.data[0]?.inventoryTypeId?.inventoryTypeId ',
              //   resp.data[0]?.inventoryTypeId?.inventoryTypeId
              // );
              // console.log('_Item.inventoryTypeId', _Item.inventoryTypeId);

              if (
                resp.data[0]?.inventoryTypeId?.inventoryTypeId ===
                _Item.inventoryTypeId
              ) {
                if (inventory.data[0].floorRise[0].value) {
                  inventory.data[0].floorRise.forEach((item) => {
                    if (
                      item.from <= resp.data[0].floorNo &&
                      item.to >= resp.data[0].floorNo
                    ) {
                      if (item.type === 'Percentage') {
                        if (resp.data[0].saleableArea === _Item.sqft) {
                          const floorRise_per_unit =
                            (parseInt(_Item.BSPTotal) * parseInt(item.value)) /
                            100;
                          setFloorRiseValue(floorRise_per_unit);
                        }
                      } else if (item.type === 'Value') {
                        const floorRise_per_unit_by_Value = parseInt(
                          item.value
                        );
                        setFloorRiseValue(floorRise_per_unit_by_Value);
                      }
                    }
                  });
                }

                if (inventory.data[0].plc !== null) {
                  inventory.data[0].plc.forEach((item) => {
                    if (resp.data[0].view === '') {
                      if (item.type === 'Percentage') {
                        if (resp.data[0].saleableArea === _Item.sqft) {
                          const plc_per_unit =
                            (parseInt(_Item.BSPTotal) * parseInt(item.value)) /
                            100;
                          setPlcValue(plc_per_unit);
                        }
                      } else if (item.type === 'Value') {
                        const plc_per_unit_by_Value = parseInt(item.value);
                        setPlcValue(plc_per_unit_by_Value);
                      }
                    }
                  });
                }
              }
            });

            setProjectPricingDetails(resp.data);
            setPricingDetails(inventory.data);
          })
          .catch((err) => {
            console.error('getProjectPricingByUnitId', err);
          });
        // setUnitData(resp.data);
      })
      .catch((err) => {
        console.error('unit-details-error', err);
      });
  }

  function defineChipColor() {
    let obj = {};
    console.log('---->', ProjectPricingDetails);
    if (ProjectPricingDetails[0]?.inventoryStatusId?.status === 'Available') {
      obj.chipColor = '#027A48';
      obj.chipBackgroundColor = '#D1FADF';
    } else if (
      ProjectPricingDetails[0]?.inventoryStatusId?.status === 'On Hold'
    ) {
      obj.chipColor = '#B54708';
      obj.chipBackgroundColor = '#FEF0C7';
    } else if (
      ProjectPricingDetails[0]?.inventoryStatusId?.status === 'Payment Pending'
    ) {
      obj.chipColor = '#B42318';
      obj.chipBackgroundColor = '#FEE4E2';
    } else if (
      ProjectPricingDetails[0]?.inventoryStatusId?.status === 'Reserved'
    ) {
      obj.chipColor = '#6941C6';
      obj.chipBackgroundColor = '#F4EBFF';
    } else if (
      ProjectPricingDetails[0]?.inventoryStatusId?.status === 'Locked'
    ) {
      obj.chipColor = '#344054';
      obj.chipBackgroundColor = '#F2F4F7';
    } else if (
      ProjectPricingDetails[0]?.inventoryStatusId?.status === 'Preselected'
    ) {
      obj.chipColor = '#FF4405';
      obj.chipBackgroundColor = '#FFE6D5';
    } else if (
      ProjectPricingDetails[0]?.inventoryStatusId?.status === 'Kyc Pending'
    ) {
      obj.chipColor = '#0E7090';
      obj.chipBackgroundColor = '#ECFDFF';
    } else if (
      ProjectPricingDetails[0]?.inventoryStatusId?.status === 'Kyc Done'
    ) {
      obj.chipColor = '#0E7090';
      obj.chipBackgroundColor = '#ECFDFF';
    } else if (
      ProjectPricingDetails[0]?.inventoryStatusId?.status ===
      'SDR Payment Pending'
    ) {
      obj.chipColor = '#B54708';
      obj.chipBackgroundColor = '#FFFAEB';
    }
    setChipStyle(obj);
  }

  //*Project-details
  function getProjectPriceDetails() {
    //*to get project-Details
    getProjectByProjectName(projectId)
      .then((res) => {
        console.log('Project-details', res);
        setProjectData(res.data);
        getUnitByUnitNo(unitNo)
          .then((UnitDetails) => {
            //*get Booking Amounts
            console.log(
              '[0].inventoryTypeId.inventoryTypeId',
              UnitDetails.data[0].inventoryTypeId.inventoryTypeId
            );
            console.log("projectId - ------", projectId)
            console.log("wingName=====>", wingName)
            console.log("-------------->", UnitDetails.data[0].inventoryTypeId.inventoryTypeId)
            CheckBookingAmounts(
              projectId,
              wingName,
              UnitDetails.data[0].inventoryTypeId.inventoryTypeId
            )
              .then((response33) => {
                console.log('Booking-amount-Data', response33);
                setBookingAmountData(response33);
              })
              .catch((err) => {
                console.error('booking-Amount-err', err);
              });
            console.log('Inventory-check', UnitDetails.data);
            getAllPricingPlansByLaunch(projectId, wingName)
              .then((projectPlans) => {
                console.log('***', { projectPlans });
                let filteredData = projectPlans.data.filter(
                  ({ projectPricingId }) => projectPricingId !== null
                );
                // console.log("filteredData", filteredData.length)

                // console.log("UnitDetails.data[0]?.BSP", UnitDetails.data[0]?.BSP)
                // console.log("res.data[0]?.useCsvPrice", res.data[0]?.useCsvPrice)

                if (res.data[0]?.useCsvPrice === false) {
                  setCsvUploaded(false);
                  console.log('***', filteredData);
                  setListOfProjectPricing([...filteredData]);

                  // **To set byDefault in list whose startDateTime and endDateTime is null
                  let findingFirstTitle = filteredData.filter(
                    (el) =>
                      !el.projectPricingId.startDateTime &&
                      !el.projectPricingId.endDateTime
                  );
                  if (filteredData.length === 0) {
                    setPriceNotAdded(true);
                  }
                  console.log('finding-first-title', { findingFirstTitle });
                  setSelectedProjectPricingTitle(
                    findingFirstTitle[0]?.projectPricingId.title
                  );
                  // **Check for saleableArea and InventoryTypeId compare in basePrices
                  checkInBasePriceList(findingFirstTitle[0]);
                } else if (res.data[0]?.useCsvPrice === true) {
                  setCsvUploaded(true);
                  console.log('unit-data', UnitDetails.data);
                  getUnitCancellation(UnitDetails.data[0]?.unitId).then((cancellationResp) => {
                    // console.log('cancellationResp: ', cancellationResp);
                    // if (cancellationResp.data.length === 0) {
                    //   // ! if any error in fetching cancellation requests; show price not added because not sure if repricing done or not
                    //   setPriceNotAdded(true);
                    // }
                    if (
                      UnitDetails.data[0]?.BSP === null ||
                      (UnitDetails.data[0]?.BSP === 0 &&
                        UnitDetails.data[0]?.GST === 0 &&
                        UnitDetails.data[0]?.SDR === 0)
                    ) {
                      setPriceNotAdded(true);
                      if (
                        UnitDetails.data[0]?.BSP === 0 &&
                        UnitDetails.data[0]?.GST === 0 &&
                        UnitDetails.data[0]?.SDR === 0
                      ) {
                        setAfterCancelUnitPrice(true);
                      }
                    } else {
                      if (cancellationResp?.data?.[0]?.CancelUnitRequests?.[0]?.status === 'Accepted' && cancellationResp?.data?.[0]?.CancelUnitRequests?.[0]?.unitPriceAlreadyUpdated === false && cancellationResp?.data?.[0]?.CancelUnitRequests?.[0]?.isSkipReprice === false) {
                        setPriceNotAdded(true);
                        setAfterCancelUnitPrice(true);
                      }
                    }
                  }).catch((err) => {
                    console.log('Error in fetching cancellation requests: ', err);
                    // ! if any error in fetching cancellation requests; show price not added because not sure if repricing done or not
                    setPriceNotAdded(true);
                  });
                  setPricingDetails(UnitDetails.data);
                } else if ((UnitDetails.data[0]?.BSP === null && filteredData.length === 0) || res.data[0]?.useCsvPrice === null) {
                  setPriceNotAdded(true);
                }
                let saleableArea = UnitDetails.data[0].saleableArea;
                setSaleableArea(saleableArea);
              })
              .catch((err) => {
                console.error(err);
              });
          })
          .catch((err) => {
            console.error(err);
          });
      })
      .catch((err) => {
        console.error('Project-details', err);
      });

    //*to get event-Details
    getEventByEventName(eventID)
      .then((response77) => {
        console.log('Event-Data', response77);
        setEventDurationData(response77);
        if (response77[0].salesManagerDeskPaymentModes.length > 0) {
          setPayNowButton(true);
        } else {
          setPayNowButton(false);
        }
      })
      .catch((err) => {
        console.error('Event-Data', err);
      });

    //*to get inventory-Statuses
    getAllInventoryStatusFromTable()
      .then((resp) => {
        console.log('Inventory=Status', resp);
        const AllotedStatus = resp.data.filter(
          (f) => f.status === 'Payment Pending'
        );
        console.log('Alloted-Status', AllotedStatus[0]?.inventoryStatusId);
        setAllottedInventoryStatus(AllotedStatus[0]?.inventoryStatusId);

        const onHoldStatus = resp.data.filter((f) => f.status === 'On Hold');
        console.log('on-Hold-Status', onHoldStatus[0]?.inventoryStatusId);
        setHoldInventoryStatus(onHoldStatus[0]?.inventoryStatusId);

        const onPreSelectStatus = resp.data.filter(
          (f) => f.status === 'Preselected'
        );
        console.log('on-Hold-Status', onPreSelectStatus[0]?.inventoryStatusId);
        setPreSelectInventoryStatus(onPreSelectStatus[0]?.inventoryStatusId);

        const kycPending = resp.data.filter((f) => f.status === 'Kyc Pending');
        setKycPendingInventoryStatus(kycPending[0]?.inventoryStatusId);
      })
      .catch((err) => {
        console.error('Inventory=Status', err);
      });

    //*to get unit-Status
    getUnitByUnitNo(unitNo)
      .then((response88) => {
        console.log('getUnitStatus', response88);
        setTotalBsp(response88.data[0]);
        let saleableArea = response88.data[0].saleableArea;
        setSaleableArea(saleableArea);
        let preSelectRoute1 = sessionStorage.getItem('GlobalLeadPreSelected');
        //*for preselect-Allotment
        if (preSelectRoute1 === 'true') {
          console.log('preSelectRoute1', preSelectRoute1);
          let Info = JSON.parse(
            sessionStorage.getItem('GlobalLeadPreSelectedLeadData')
          );
          if (Info?.selectedEventToken?.tokenId?.isPreselect === true) {
            setLeadId(Info?.leadId);
            setPreSelectInfo(Info);
            setPreSelectedLead(true);
            let PreSelectLeadDetails = {
              LeadName: Info?.person.name,
              LeadDisplayId: Info?.leaddisplayid.replace(
                Info?.leaddisplayid.substring(8, 12),
                '-' + Info?.leaddisplayid.substring(8, 12)
              ),
              LeadMobileNumber: Info?.leadcontactnumber,
              LeadEmail: Info?.leademail,
            };

            setLeadData([PreSelectLeadDetails]);
            // ! to show lead details of lead who has preselected the unit
            // setOnHoldData(true);
            // const LeadDetails = response88.data.map((el) => ({
            //   ...el,
            //   Name: el?.leadId.personId?.name,
            //   DisplayId: el?.leadId.leadDisplayId.replace(
            //     el?.leadId.leadDisplayId.substring(8, 12),
            //     "-" + el?.leadId.leadDisplayId.substring(8, 12)
            //   ),
            //   MobileNumber: el?.leadId.personId.contactNumber,
            //   Email: el?.leadId.personId.email,
            // }));
            // setOnHoldDetails(LeadDetails);
            // ! why get AllotmentPayment row for current selected lead?
            // getLeadFromAllotment(unitNo, Info?.leadId).then((response66) => {
            //   console.log("getLeadFromAllotment", response66);
            //   if (response66.count > 0) {
            //     response66.data[0].allotmentpaymentid =
            //       response66.data[0].allotmentPaymentId;
            //     setAllotmentIdData(response66.data);
            //     // setPreSelectPayNow(true);
            //   }
            // });
          }
        } else {
          if (response88.data) {
            getAllLeadNameForToken(eventID)
              .then((response77) => {
                console.log('response77 =========> ', response77);
                // !!Sarita changes after adding team leadid can be null is userId not found
                response77.data = response77.data.filter(
                  ({ leadId }) => leadId !== null
                );
                const UniqData = uniqBy(response77.data, 'leadId.leadId');
                console.log('UniqData', UniqData);
                let temp = [];
                UniqData.forEach((el) => {
                  if (
                    el?.leadId?.LeadStatus?.length > 0 &&
                    el?.leadId?.personId !== null
                  ) {
                    temp.push(el);
                    // console.log(el);
                  }
                });
                const AvailableData = temp.map((lead) => ({
                  ...lead,
                  LeadName: lead?.leadId?.personId?.name,
                  LeadDisplayId:
                    'VJ' +
                    lead.leadId.leadDisplayId.replace(
                      lead.leadId.leadDisplayId.substring(8, 12),
                      '-' + lead.leadId.leadDisplayId.substring(8, 12)
                    ),
                }));
                console.log('Final-Array', temp);
                setAllLeads(AvailableData);
                if (
                  response88.data[0]?.leadId?.leadId &&
                  response88.data[0]?.inventoryStatusId?.status !== 'Available'
                ) {
                  setOnHoldData(true);
                  const LeadDetails = response88.data.map((el) => ({
                    ...el,
                    Name: el?.leadId.personId?.name,
                    DisplayId: el?.leadId.leadDisplayId.replace(
                      el?.leadId.leadDisplayId.substring(8, 12),
                      '-' + el?.leadId.leadDisplayId.substring(8, 12)
                    ),
                    MobileNumber: el?.leadId.personId.contactNumber,
                    Email: el?.leadId.personId.email,
                  }));
                  setOnHoldDetails(LeadDetails);
                  const onHoldLead = response88.data.map((el) => ({
                    ...el,
                    LeadName: el?.leadId.personId?.name,
                    LeadDisplayId:
                      'VJ' +
                      el?.leadId.leadDisplayId.replace(
                        el?.leadId.leadDisplayId.substring(8, 12),
                        '-' + el?.leadId.leadDisplayId.substring(8, 12)
                      ),
                  }));

                  setAllLeads([...AvailableData, ...onHoldLead]);
                  console.log('All-Leads', AllLeads);
                }
              })
              .catch((err) => {
                console.error('getAllLeadNameForToken', err);
              });
          }
        }
      })
      .catch((err) => {
        console.error('getUnitStatus', err);
      });
  }
  //*Searching Data in Leads
  const SearchDataInLeads = debounce((_value) => {
    setLeadName(_value);
    console.log(_value.split(' ').splice(-1));
    if (_value !== '') {
      const SelectedValue = _value.split(' ').splice(-1);
      const FinalValue = SelectedValue[0].slice(2).split('-').join('');
      console.log('FinalValue', FinalValue);
      if (FinalValue !== '') {
        getLeadForToken(eventID, FinalValue)
          .then((response33) => {
            console.log('response33 ===> ', response33); 
            console.log(
              'Lead_Data',
              response33.data.filter((f) => f.leadId !== null)
            );
            const FinalLead = response33.data.filter((f) => f.leadId !== null);
            console.log(FinalLead);
            if (OnHoldData === true && FinalLead.length === 0) {
              setSameUser(true);
              setInterestQueueTable(false);
            }
            const Data = uniqBy(FinalLead, 'leadId.leadId');
            //*getting Lead Details after Search lead Id
            const LeadCard = Data.map((el) => ({
              ...el,
              LeadName: el?.leadId.personId.name,
              LeadDisplayId: el?.leadId.leadDisplayId.replace(
                el?.leadId.leadDisplayId.substring(8, 12),
                '-' + el?.leadId.leadDisplayId.substring(8, 12)
              ),
              LeadMobileNumber: el?.leadId.personId.contactNumber,
              LeadEmail: el?.leadId.personId.email,
            }));
            setLeadData(LeadCard);
            console.log('Final-Lead', FinalLead);
            setLeadId(FinalLead[0]?.leadId.leadId);
            console.info('setLeadID', LeadID);
            setSelectedLeadDisplayId(
              FinalLead[0]?.leadId.leadDisplayId.replace(
                FinalLead[0]?.leadId.leadDisplayId?.substring(8, 12),
                '-' + FinalLead[0]?.leadId.leadDisplayId.substring(8, 12)
              )
            );
            setSelectedLeadName(FinalLead[0]?.leadId.personId.name);
            if (FinalLead[0]?.checkpt2 === false) {
              setCheckPt2Message(true);
              setDisabledInterest(true);
              setInterestQueueTable(false);
            } else if (FinalLead[0]?.checkpt2 === true) {
              setCheckPt2Message(false);
              console.log('lead', FinalLead?.leadId?.leadId);
        console.log("NextStepWithLeadId called 33333");

              NextStepWithLeadId(FinalLead[0].leadId.leadId);
            }
          })
          .catch((err) => {
            console.error('Lead_Data', err);
          });
      }
    } else if (_value === '') {
      console.log('setPaymentDetailsButton111');
      setPaymentDetailsButton(true);
    }

    //* if user doesn't type anything and clicks on search
    if (AllotmentData.displayName === '') {
      setHelperText((pre) => {
        pre.displayName = 'Type leadID or name to search';
        return { ...pre };
      });
    }
  });

  function NextStepWithLeadId(lead) {
    console.log('leadId', lead);

    //*checking to allow payment button or show interest Button
    getLeadDetailsForSustenance(lead, unitNo)
      .then((response02) => {
        console.log('response02', response02); //*check if added in interest queue
        getLeadDetailsFromInventory(unitNo)
          .then((resp5) => {
            console.log(
              'resp5 =======>',
              resp5.data[0].leadId
            ); //* check lead added in Inventory Table
            getSelectedToken(lead, eventID).then((response45) => {
              console.log('getSelectedToken response45 ======> ', response45);
              if (response45.count > 0) {
                setTokenMessage(false);
                
                setPaymentDetailsButton(false);
                getUnitStatus(unitNo)
                  .then((resp8) => {
                    console.info('check Status of unit', resp8); //* check Status of unit(hold or available)
                    console.log('lead', lead);
                    if (
                      lead === resp5.data[0].leadId &&
                      resp8[0].InventoryStatus.status === 'Payment Pending'
                    ) {
                      console.info('exists in inventory table , alloted unit');
                      setDisabledInterest(true);
                      console.log('setPaymentDetailsButton222');
                      setPaymentDetailsButton(true);
                      setSameUser(true);
                      setInterestQueueTable(false);
                    } else if (lead === resp5.data[0].leadId) {
                      console.info('yes! exists in inventory table, hi again');
                      setDisabledInterest(true);
                      console.log('setPaymentDetailsButton333');

                      setPaymentDetailsButton(true);
                      setSameUser(true);
                      setInterestQueueTable(false);
                    } else {
                      console.info(
                        'No! does-not exists in inventory table , its your first time here'
                      );
                      //*case 1 :unit is available & Interest queue is empty , payment Button: allow
                      if (
                        response02.count === 0 &&
                        resp8[0].InventoryStatus.status === 'Available'
                      ) {
                        console.info(
                          'unit is available & Interest queue is empty , payment Button: allow',
                          BookingAmountData
                        );

                        setPaymentDetailsButton(false);
                        setSameUser(false);
                        //*case 2: unit is on Hold & lead is not added , show interest button: allow
                      } else if (
                        response02.count === 0 &&
                        resp8[0].InventoryStatus.status !== 'Available'
                      ) {
                        console.info(
                          'unit is on Hold & lead is not added , show interest button: allow'
                        );
                        setDisabledInterest(false);
                      console.log('setPaymentDetailsButton444');

                        setPaymentDetailsButton(true);
                        setInterestQueueTable(true);
                        setSameUser(false);
                        //*case 3 :unit is on Hold  & lead exists in interest queue, ask him to wait till unit : available
                      } else if (response02.count > 0) {
                        console.info(
                          'unit is on Hold  & lead exists in interest queue, ask him to wait till unit : available'
                        );
                        setDisabledInterest(true);
                      console.log('setPaymentDetailsButton555');
                        
                        setPaymentDetailsButton(true);
                        setSameUser(false);
                        setInterestQueueTable(true);
                        infoTost(
                          "You have already shown Interest But Unit is on hold , Please wait until it's available"
                        );
                        // errorTost(`Lead  has been already added!`);
                        //*case 4 : unit is alloted & lead is not the alloted user , he can't do anything
                      } else if (
                        resp8[0].InventoryStatus.status === 'Payment Pending' &&
                        response02.count === 0
                      ) {
                        setDisabledInterest(true);
                      console.log('setPaymentDetailsButton666');

                        setPaymentDetailsButton(true);
                        setSameUser(false);
                        console.info('Unit is Allotted!');
                        //*case 5: unit is available & lead exists in interest queue , payment Button : allow
                      } else if (
                        resp8[0].InventoryStatus.status === 'Available' &&
                        response02.count > 0
                      ) {
                        console.info(
                          'unit is available & Interest queue is not empty , payment Button: allow'
                        );
                        setPaymentDetailsButton(false);
                        setSameUser(false);
                        //*case 6 : unit is allotted & lead has done only partial payment , payment Button : allow
                      } else if (
                        resp8[0].InventoryStatus.status === 'Payment Pending' &&
                        lead === resp5.data[0].leadId
                      ) {
                        setDisabledInterest(true);
                      console.log('setPaymentDetailsButton777');

                        setPaymentDetailsButton(true);
                        setSameUser(true);
                      }
                    }
                  })
                  .catch((err) => {
                    console.error('check Status of unit', err);
                  });
              } else {
                console.log('ELSE PART EXECUTING =========>');
                setTokenMessage(true);
                if (getAlotEventGlobalLeadAvailable()) {
                  setPaymentDetailsButton(false);
                } else {
                      console.log('setPaymentDetailsButton888');

                  setPaymentDetailsButton(true);
                }
              }
            });
          })
          .catch((err) => {
            console.error('check lead added in Inventory Table', err);
          });
      })
      .catch((err) => {
        console.error('check if added in interest queue', err);
      });
  }

  function PutTheUnitOnHold(value) {

    console.log('PutTheUnitOnHold called with value ===============> ', value);
    console.log('Value-clicked', value);
    console.info('LeadID', LeadID);
    presentLoader();
    getUnitStatus(unitNo)
      .then((res) => {
        console.info('unit-Data', res); //*check Unit Status
        console.info('Unit-Status', res[0].InventoryStatus.status);
        //*steps: put the unit to on hold
        //*step 1: insert into Allotment table
        console.log({ UnitData });
        if (BookingAmountData.length > 0) {
          if (res[0].InventoryStatus.status === 'Available') {
            let paidAlready = 0;
            let paidAmtObj = {
              ocr: null,
              gst: null,
              sdr: null,
            };
            let eventAllotment = getAlotEventLead();
            console.log('eventAllotment: ', eventAllotment);
            if (eventAllotment?.oldAllotmentData) {
              paidAlready = eventAllotment?.oldAllotmentData?.updatedunitprice ?
                eventAllotment?.oldAllotmentData?.paidamount -
                eventAllotment?.oldAllotmentData?.updatedunitprice?.cancellationCharges :
                eventAllotment?.oldAllotmentData?.paidamount;
              // ??variable "newAmount" used for bucketing
              let newAmount = eventAllotment?.oldAllotmentData?.updatedunitprice ?
                eventAllotment?.oldAllotmentData?.paidamount -
                eventAllotment?.oldAllotmentData?.updatedunitprice?.cancellationCharges :
                eventAllotment?.oldAllotmentData?.paidamount;
              // ??newAmount is less than BookingAmountData
              if (newAmount <= BookingAmountData[0]?.TOTAL) {
                if (newAmount <= BookingAmountData[0]?.OCR) {
                  paidAmtObj.ocr = newAmount;
                  newAmount = 0;
                } else if (newAmount > BookingAmountData[0].OCR) {
                  paidAmtObj.ocr = BookingAmountData[0]?.OCR;
                  newAmount = newAmount - BookingAmountData[0]?.OCR;
                }
                if (newAmount <= BookingAmountData[0]?.GST) {
                  paidAmtObj.gst = newAmount;
                  newAmount = 0;
                } else if (newAmount > BookingAmountData[0]?.GST) {
                  paidAmtObj.gst = BookingAmountData[0]?.GST;
                  newAmount = newAmount - BookingAmountData[0]?.GST;
                }
                if (newAmount <= BookingAmountData[0]?.SDR) {
                  paidAmtObj.sdr = newAmount;
                  newAmount = 0;
                } else if (newAmount > BookingAmountData[0]?.SDR) {
                  paidAmtObj.sdr = BookingAmountData[0]?.SDR;
                  newAmount = newAmount - BookingAmountData[0]?.SDR;
                }
              } else {
                // !!Flow for if BookingAmountData[0].TOTAL >newAmount
                // ??Same flow like before
                if (newAmount <= BookingAmountData[0]?.OCR) {
                  paidAmtObj.ocr = newAmount;
                  newAmount = 0;
                } else if (newAmount > BookingAmountData[0]?.OCR) {
                  paidAmtObj.ocr = BookingAmountData[0]?.OCR;
                  newAmount = newAmount - BookingAmountData[0]?.OCR;
                }
                if (newAmount <= BookingAmountData[0]?.GST) {
                  paidAmtObj.gst = newAmount;
                  newAmount = 0;
                } else if (newAmount > BookingAmountData[0]?.GST) {
                  paidAmtObj.gst = BookingAmountData[0]?.GST;
                  newAmount = newAmount - BookingAmountData[0]?.GST;
                }
                if (newAmount <= BookingAmountData[0]?.SDR) {
                  paidAmtObj.sdr = newAmount;
                  newAmount = 0;
                } else if (newAmount > BookingAmountData[0]?.SDR) {
                  paidAmtObj.sdr = BookingAmountData[0]?.SDR;
                  newAmount = newAmount - BookingAmountData[0]?.SDR;
                }
                // ??After bucket is filled now bucket filling from comparing from Unit Cost
                if (newAmount <= UnitData[0]?.BSP - BookingAmountData[0]?.OCR) {
                  paidAmtObj.ocr = paidAmtObj.ocr + newAmount;
                  newAmount = 0;
                } else if (
                  newAmount >
                  UnitData[0]?.BSP - BookingAmountData[0]?.OCR
                ) {
                  paidAmtObj.ocr =
                    paidAmtObj.ocr +
                    (UnitData[0]?.BSP - BookingAmountData[0]?.OCR);
                  newAmount =
                    newAmount - (UnitData[0]?.BSP - BookingAmountData[0]?.OCR);
                }
                if (newAmount <= UnitData[0]?.SDR - BookingAmountData[0]?.SDR) {
                  paidAmtObj.sdr = paidAmtObj.sdr + newAmount;
                  newAmount = 0;
                } else if (
                  newAmount >
                  UnitData[0]?.SDR - BookingAmountData[0]?.SDR
                ) {
                  paidAmtObj.sdr =
                    paidAmtObj.sdr +
                    (UnitData[0]?.SDR - BookingAmountData[0]?.SDR);
                  newAmount =
                    newAmount - (UnitData[0]?.SDR - BookingAmountData[0]?.SDR);
                }
                if (newAmount <= UnitData[0]?.GST - BookingAmountData[0]?.GST) {
                  paidAmtObj.gst = paidAmtObj.gst + newAmount;
                  newAmount = 0;
                } else if (
                  newAmount >
                  UnitData[0]?.GST - BookingAmountData[0]?.GST
                ) {
                  paidAmtObj.gst =
                    paidAmtObj.gst +
                    (UnitData[0]?.GST - BookingAmountData[0]?.GST);
                  newAmount =
                    newAmount - (UnitData[0]?.GST - BookingAmountData[0]?.GST);
                }
              }

              console.log({ paidAmtObj });
            }

            console.log("paidAlready", paidAlready)

            const isPaymentTabForAssignNewUnit = sessionStorage.getItem('isPaymentTab')

            let AllotmentDetails = {
              firstPaymentDate: isPaymentTabForAssignNewUnit && paidAlready === 0 ? Date.now() : null,
              leadId: LeadID,
              userId: loggedInUser?.userId,
              unitId: mergeIdData === true ? null : unitNo,
              eventId: eventID,
              unitCost: {
                bsp: csvUploaded
                  ? mergeIdData
                    ? parseFloat(TotalBsp?.BSP) + parseFloat(TotalBsp?.BSP)
                    : parseFloat(TotalBsp?.BSP)
                  : mergeIdData
                    ? parseFloat(TotalBsp?.BSPTotal) +
                    parseFloat(TotalBsp?.BSPTotal)
                    : parseFloat(TotalBsp?.BSPTotal),
                sdr: mergeIdData
                  ? parseFloat(TotalBsp?.SDR) + parseFloat(TotalBsp?.SDR)
                  : parseFloat(TotalBsp?.SDR),
                gst: mergeIdData
                  ? parseFloat(TotalBsp?.GST) + parseFloat(TotalBsp?.GST)
                  : parseFloat(TotalBsp?.GST),
                total: csvUploaded
                  ? mergeIdData
                    ? parseFloat(
                      TotalBsp?.totalCost +
                      TotalBsp?.totalCost
                      //  + FloorRiseValue
                    )
                    : parseFloat(TotalBsp?.totalCost)
                  : mergeIdData
                    ? parseFloat(
                      TotalBsp?.Total + TotalBsp?.Total
                      //  + FloorRiseValue
                    )
                    : parseFloat(TotalBsp?.Total),
              },
              bookingAmt: {
                ocr: BookingAmountData[0].OCR,
                sdr: BookingAmountData[0].SDR,
                gst: BookingAmountData[0].GST,
                total: BookingAmountData[0].TOTAL,
              },
              paymentPlan: selectedProjectPaymentPlan === null ? null : selectedProjectPaymentPlan?.title === "none" ? null : {
                ...selectedProjectPaymentPlan,
              },
              paymentPlanId: selectedProjectPaymentPlan === null ? null : selectedProjectPaymentPlan?.title === "none" ? null : selectedProjectPaymentPlan ? selectedProjectPaymentPlan?.paymentPlanId : null,
              pricingType: "event",
              paymentId: getAlotEventLead()?.oldAllotmentData
                ? getAlotEventLead()?.paymentId
                : TokenData.token,
              paidAmount: getAlotEventLead()?.oldAllotmentData
                ? paidAlready
                : 0,
              inventoryMergedId: mergeIdData === true ? mergeID : null,
              //??allotment status
              status: getAlotEventLead()?.oldAllotmentData
                ? paidAlready >= BookingAmountData[0].TOTAL
                  ? 'Payment Complete'
                  : 'Partial Payment Done'
                : value === 'Hold & Continue'
                  ? 'Payment Pending'
                  : 'On Hold', // ! vedashree changes here,
              // getAlotEventLead()?.oldAllotmentData ? paidAmtObj :
              paidAmt: null,
              launchId: launchId
            };
            let unitStatusArray = [];
            if (mergeIdData === true) {
              unitStatusArray.push({
                StatusId: getAlotEventLead()?.oldAllotmentData
                  ? paidAlready >= BookingAmountData[0].TOTAL
                    ? kycPendingInventoryStatus
                    : allotedInventoryStatus
                  : value === 'Hold & Continue'
                    ? allotedInventoryStatus
                    : HoldInventoryStatus,
                unitId: Unit1,
                leadId: LeadID,
                UnitHoldTime: new Date().getTime(),
              });
              unitStatusArray.push({
                StatusId: getAlotEventLead()?.oldAllotmentData
                  ? paidAlready >= BookingAmountData[0].TOTAL
                    ? kycPendingInventoryStatus
                    : allotedInventoryStatus
                  : value === 'Hold & Continue'
                    ? allotedInventoryStatus
                    : HoldInventoryStatus,
                unitId: Unit2,
                leadId: LeadID,
                UnitHoldTime: new Date().getTime(),
              });
            } else {
              unitStatusArray.push({
                StatusId: getAlotEventLead()?.oldAllotmentData
                  ? paidAlready >= BookingAmountData[0].TOTAL
                    ? kycPendingInventoryStatus
                    : allotedInventoryStatus
                  : value === 'Hold & Continue'
                    ? allotedInventoryStatus
                    : HoldInventoryStatus,
                unitId: unitNo,
                leadId: LeadID,
                UnitHoldTime: new Date().getTime(),
              });
            }
            const leadStatus =
              value === 'Hold & Continue'
                ? 'Allotment Payment Pending'
                : 'Unit On Hold';

            console.log({ AllotmentDetails });
            ///* Algo Shift to Server
            //! start
            // InsertIntoAllotmentTable(AllotmentDetails).then((response44) => {
            //     console.log('Added-into-Allotment-table', response44);
            //     //*step 1:add to leadId to inventory Table and put status onHold
            //     if (mergeIdData === true) {
            //       UpdateUnitStatus(
            //         // ! vedashree changes here
            //         value === 'Hold & Continue'
            //           ? allotedInventoryStatus
            //           : HoldInventoryStatus,
            //         // HoldInventoryStatus,
            //         Unit1,
            //         LeadID,
            //         new Date().getTime()
            //       )
            //         .then((response34) => {
            //           console.log('Status-updated', response34);
            //           let InventoryLogObj = {
            //             userId: loggedInUser?.userId,
            //             leadId: LeadID,
            //             // ! vedashree changes here
            //             status:
            //               value === 'Hold & Continue'
            //                 ? 'Payment Pending'
            //                 : 'On Hold',
            //             // status: "on hold",
            //             eventId: eventID,
            //             unitId: Unit1,
            //           };
            //           insertInventoryLogs(InventoryLogObj)
            //             .then((insertInventoryLogsRes) => {
            //               console.log({ insertInventoryLogsRes });
            //             })
            //             .catch((err) => {
            //               console.log(
            //                 'err while inserting into inventory log',
            //                 err
            //               );
            //             });
            //         })
            //         .catch((err) => {
            //           console.log('Status-updated', err);
            //         });
            //       UpdateUnitStatus(
            //         // ! vedashree changes here
            //         value === 'Hold & Continue'
            //           ? allotedInventoryStatus
            //           : HoldInventoryStatus,
            //         // HoldInventoryStatus,
            //         Unit2,
            //         LeadID,
            //         new Date().getTime()
            //       )
            //         .then((response34) => {
            //           console.log('Status-updated', response34);
            //           let InventoryLogObj = {
            //             userId: loggedInUser?.userId,
            //             leadId: LeadID,
            //             // ! vedashree changes here
            //             status:
            //               value === 'Hold & Continue'
            //                 ? 'Payment Pending'
            //                 : 'On Hold',
            //             // status: "on hold",
            //             eventId: eventID,
            //             unitId: Unit2,
            //           };
            //           insertInventoryLogs(InventoryLogObj)
            //             .then((insertInventoryLogsRes) => {
            //               console.log({ insertInventoryLogsRes });
            //             })
            //             .catch((err) => {
            //               console.log(
            //                 'err while inserting into inventory log',
            //                 err
            //               );
            //             });
            //         })
            //         .catch((err) => {
            //           console.log('Status-updated', err);
            //         });
            //     } else {
            //       UpdateUnitStatus(
            //         // ! vedashree changes here
            //         value === 'Hold & Continue'
            //           ? allotedInventoryStatus
            //           : HoldInventoryStatus,
            //         // HoldInventoryStatus,
            //         unitNo,
            //         LeadID,
            //         new Date().getTime()
            //       )
            //         .then((response34) => {
            //           console.log('Status-updated', response34);
            //           let InventoryLogObj = {
            //             userId: loggedInUser?.userId,
            //             leadId: LeadID,
            //             // ! vedashree changes here
            //             status:
            //               value === 'Hold & Continue'
            //                 ? 'Payment Pending'
            //                 : 'On Hold',
            //             // status: "on hold",
            //             eventId: eventID,
            //             unitId: unitNo,
            //           };
            //           insertInventoryLogs(InventoryLogObj)
            //             .then((insertInventoryLogsRes) => {
            //               console.log({ insertInventoryLogsRes });
            //             })
            //             .catch((err) => {
            //               console.log(
            //                 'err while inserting into inventory log',
            //                 err
            //               );
            //             });
            //         })
            //         .catch((err) => {
            //           console.log('Status-updated', err);
            //         });
            //     }
            //     //*step 4: Update-Lead-status
            //     updateLeadStatusForAllotment(
            //       LeadID,
            //       value === 'Hold & Continue'
            //         ? 'Allotment Payment Pending'
            //         : 'Unit On Hold',
            //       // value === 'Hold & Continue' ? 'Payment Pending' : 'Unit On Hold',
            //       response44.data[0].allotmentPaymentId,
            //       response44.data[0].paymentId
            //     )
            //       .then((response11) => {
            //         let obj = {
            //           leadId: LeadID,
            //           leadStatus:
            //             value === 'Hold & Continue'
            //               ? 'Allotment Payment Pending'
            //               : 'Unit On Hold',
            //           message: `Unit ${UnitData[0].wingId.wingName}-${UnitData[0].unitNo} InventoryType-${UnitData[0].inventoryTypeId.type} Put on Hold by ${loggedInUser.name}(${loggedInUser.roleId.title})`,
            //         };
            //         addLeadLogs(obj)
            //           .then((leadLog) => {
            //             console.log(leadLog);
            //           })
            //           .catch((err) => {
            //             console.log('leadlog', err);
            //           });
            //         console.info('lead-Status-Updated', response11);
            //         //*step 4: Updating-token-Status
            //         UpdateTokenStatus(response44.data[0].paymentId)
            //           .then((response23) => {
            //             console.log('Updated-Token-Status', response23);
            //             console.log('paynow-button', PayNowButton);
            //             if (
            //               PayNowButton === true &&
            //               value === 'Hold & Continue'
            //             ) {
            //               handleClose();
            //               setOpenPaymentModal(true);
            //               response44.data[0].allotmentpaymentid =
            //                 response44.data[0].allotmentPaymentId;
            //               setAllotmentIdData(response44.data);

            //               setPayNowButton(true);
            //               if (mergeIdData === true) {
            //                 successTost(
            //                   `Hold Unit ${UnitData[0]?.wingId?.wingName} - ${Unit1Name},${Unit2Name} for ${SelectedLeadName}(VJ${SelectedLeadDisplayId})`
            //                 );
            //               } else {
            //                 successTost(
            //                   `Hold Unit ${UnitData[0]?.wingId?.wingName} - ${UnitData[0]?.unitNo} for ${SelectedLeadName}(VJ${SelectedLeadDisplayId})`
            //                 );
            //               }

            //               // handleClose();
            //             } else {
            //               handleClose();
            //               navigate(-1);
            //               if (mergeIdData === true) {
            //                 successTost(
            //                   `Hold Unit ${UnitData[0]?.wingId?.wingName} - ${Unit1Name},${Unit2Name} for ${SelectedLeadName}(VJ${SelectedLeadDisplayId})`
            //                 );
            //               } else {
            //                 successTost(
            //                   `Hold Unit ${UnitData[0]?.wingId?.wingName} - ${UnitData[0]?.unitNo} for ${SelectedLeadName}(VJ${SelectedLeadDisplayId})`
            //                 );
            //               }
            //             }
            //           })
            //           .catch((err) => {
            //             
            //           });
            //       })
            //       .catch((err) => {
            //         
            //       });
            // }).catch((err) => {
            //   
            // });
            //! End

            allotUnit(
              AllotmentDetails,
              unitStatusArray,
              getAlotEventLead()?.oldAllotmentData
                ? getAlotEventLead()?.paymentId
                : TokenData.token,
              eventID,
              UnitData,
              loggedInUser,
              getAlotEventLead()?.oldAllotmentData ? paidAlready >= BookingAmountData[0].TOTAL
                ? "Allotment Payment Complete"
                : "Allotment Partial Payment Done"
                : leadStatus
            )
              .then(async (allotUnitResponse) => {

                if (allotUnitResponse?.data?.success) {
                  if (mergeIdData === true) {
                    // successTost(
                    //   `Hold Unit ${UnitData[0]?.wingId?.wingName} - ${Unit1Name},${Unit2Name} for ${SelectedLeadName}(VJ${SelectedLeadDisplayId})`
                    // );
                    successTost(
                      `Hold Unit ${UnitData[0]?.wingId?.displayName ? UnitData[0]?.wingId?.displayName : UnitData[0]?.wingId?.wingName} - ${Unit1Name},${Unit2Name} for ${SelectedLeadName}(VJ${SelectedLeadDisplayId})`
                    );
                  } else {
                    // successTost(
                    //   `Hold Unit ${UnitData[0]?.wingId?.wingName} - ${UnitData[0]?.unitNo} for ${SelectedLeadName}(VJ${SelectedLeadDisplayId})`
                    // );
                    successTost(
                      `Hold Unit ${UnitData[0]?.wingId?.displayName ? UnitData[0]?.wingId?.displayName : UnitData[0]?.wingId?.wingName} - ${UnitData[0]?.unitNo} for ${SelectedLeadName}(VJ${SelectedLeadDisplayId})`
                    );
                  }
                  handleClose();
                  // dismissLoader();
                  if (value === "Hold & Continue") {
                    // ! call auto adjust token api
                    await autoAdjustToken(allotUnitResponse.data.allotmentPaymentId)
                    // ?? alot unit after cancellation unit update alotmentTransactions table with new id
                    if (getAlotEventLead()?.oldAllotmentData) {
                      let allotmentObj = {
                        allotmentPaymentId: allotUnitResponse.data.allotmentPaymentId,
                        unitId: mergeIdData === true ? null : unitNo
                      };
                      updateAllotmentTransactionsForTrnsUpdate(
                        getAlotEventLead()?.oldAllotmentData
                          ?.allotmentpaymentid,
                        allotmentObj
                      )
                        .then((alotmenttrnsUpdate) => {
                          let allotmentObject = {
                            paymentTransferred: true,
                          }
                          updateAllotmentPayment(allotmentObject, getAlotEventLead()?.oldAllotmentData?.allotmentpaymentid)
                            .then((updateAllotmentPaymentRes) => {
                              console.log({ updateAllotmentPaymentRes })
                            }).catch((err) => {
                              console.log(err);
                            });
                          let bucketingObj = { allotmentPaymentId: allotUnitResponse.data.allotmentPaymentId }
                          bucketingForChangeUnit(bucketingObj).then((bucketingResp) => {
                            // console.log({ bucketingResp });
                            if (bucketingResp.data.success) {
                              // ??success
                              getAllotmentPayment(
                                allotUnitResponse.data.allotmentPaymentId
                              )
                                .then((apResp) => {
                                  handleClose();
                                  if (apResp.data.length > 0) {
                                    apResp.data[0].allotmentpaymentid =
                                      apResp.data[0].allotmentPaymentId;
                                    // AllotmentIdData = apResp.data;
                                    setAllotmentIdData(apResp.data);
                                    if (getAlotEventLead()?.oldAllotmentData && paidAlready >= BookingAmountData[0].TOTAL) {
                                      dismissLoader();
                                    } else {
                                      setOpenPaymentModal(true);
                                      setPayNowButton(true);
                                    }
                                    dismissLoader();
                                  } else {
                                    errorTost(
                                      "Something went wrong. Go To All Allotments for payments!"
                                    );
                                    dismissLoader();
                                  }
                                  dismissLoader();
                                })
                                .catch((err) => {
                                  console.error("getAllotmentPayment", err);
                                });
                            } else {
                              dismissLoader();
                              errorTost(bucketingResp.data.message);
                            }
                          }).catch((err) => {
                            console.log(err);
                          });
                          // console.log({ alotmenttrnsUpdate });
                          let logObj = {
                            oldAllotmentId: getAlotEventLead()?.oldAllotmentData?.allotmentpaymentid,
                            newAllotmentId: allotUnitResponse.data.allotmentPaymentId,
                            userId: loggedInUser?.userId
                          };
                          insertTransactionLogs(logObj)
                            .then((resplog) => {


                            })
                            .catch((err) => {

                            });

                          let message = `<h4>Hi ${getAlotEventLead()?.oldAllotmentData?.leadname
                            },</h4></br>
                              <p>Adjust Allotment Done!</br>
                              Cancelled Unit:${getAlotEventLead()?.oldAllotmentData.projectname
                            },${getAlotEventLead()?.oldAllotmentData.displaywingname
                              ? getAlotEventLead()?.oldAllotmentData
                                .displaywingname
                              : getAlotEventLead()?.oldAllotmentData.wingname
                            },${getAlotEventLead()?.oldAllotmentData.unitno}</br>
                              Balance amount: ${getAlotEventLead()?.oldAllotmentData.paidamount
                            } has been adjusted in ${ProjectData[0]?.projectName
                            },${UnitData[0]?.wingId?.displayName
                              ? UnitData[0]?.wingId?.displayName
                              : UnitData[0]?.wingId?.wingName
                            }-${UnitData[0]?.unitNo}</br>
                              Done by ${loggedInUser?.name}(${loggedInUser?.roleId?.title
                            })</b></p></br>
                             `;
                          let emailbody = {
                            to: [getAlotEventLead()?.oldAllotmentData?.leademail],
                            subject: "Adjust Allotment Done through Event",
                            message: message,
                          };
                          // let messageBody = {
                          //   number: "+" + data.leadcontactnumber,
                          //   message: `Cancelled Unit:${oldAllotmentData.projectname},${oldAllotmentData.wingname},${oldAllotmentData.unitno}, balance amount: ${oldAllotmentData.paidamount} has been adjusted in ${availableData?.projectName}|${availableData?.wingName} |${availableData?.unitNo} done by ${loggedInUser?.name}(${loggedInUser?.roleId?.title})`,
                          //   is_international_number:
                          //     data.leadcontactnumber.toString().substring(0, 2) !== "91"
                          //       ? true
                          //       : false,
                          // };
                          // const sms = await sendMessage(messageBody)
                          //   .then((resp) => {
                          //     if (resp.data.success) {
                          //       return true;
                          //     } else {
                          //       if (resp?.data?.error) {
                          //         return false;
                          //       }
                          //     }
                          //   })
                          //   .catch((err) => {
                          //     return false;
                          //   });
                          const emailRes = sendMailTo(emailbody)
                            .then((resp) => {

                              if (resp.data.status === "err") {
                                return false;
                              } else {
                                return true;
                              }
                            })
                            .catch((err) => {

                              return false;
                            });

                        })
                        .catch((error) => {
                          console(
                            "error while updating transactions alottmentpayment id"
                          );
                        });
                    } else {
                      getAllotmentPayment(
                        allotUnitResponse.data.allotmentPaymentId
                      )
                        .then(async (apResp) => {
                          handleClose();
                          if (apResp.data.length > 0) {
                            apResp.data[0].allotmentpaymentid = apResp.data[0].allotmentPaymentId;
                            // AllotmentIdData = apResp.data;
                            setAllotmentIdData(apResp.data);
                            if (getAlotEventLead()?.oldAllotmentData && paidAlready >= BookingAmountData[0].TOTAL) {
                              dismissLoader();
                            } else {
                              setOpenPaymentModal(true);
                              setPayNowButton(true);
                            }
                            dismissLoader();
                          } else {
                            errorTost("Something went wrong. Go To All Allotments for payments!");
                            dismissLoader();
                          }
                          dismissLoader();
                        })
                        .catch((err) => {
                          console.error('getAllotmentPayment', err);
                        });
                    }
                  } else {
                    getUnitData();
                    dismissLoader();
                  }
                } else {
                  if (allotUnitResponse?.data?.error) {
                    errorTost(allotUnitResponse?.data?.error);
                  } else {
                    errorTost("Something went wrong! Try again");
                  }
                  handleClose();
                  dismissLoader();
                }
              }).catch((allotUnitError) => {
                dismissLoader();
                console.error('allotUnitError => ', allotUnitError);
                handleClose();
                if (
                  allotUnitError?.response.data.error &&
                  typeof allotUnitError?.response.data.error === "string"
                ) {
                  errorTost(allotUnitError?.response?.data?.error);
                } else {
                  errorTost("Something went wrong! Try again");
                }
              });
          } else {
            handleClose();
            dismissLoader();
            errorTost("Unit is not available.");
          }
        } else {
          handleClose();
          dismissLoader();
          errorTost("Booking amount not added, contact your admin.");
        }
      }).catch((err) => {
        dismissLoader();
        handleClose();
        console.info('Update-Status-err', err);
      });
  }

  function getTodayDate() {
    var dateObj = new Date();
    var month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
    var day = dateObj.getDate().toString().padStart(2, '0');
    var year = dateObj.getUTCFullYear();
    return year.toString() + month.toString() + day.toString();
  }

  function PreSelectAllotment() {
    presentLoader();
    let AllotmentPreSelectDetails = {
      leadId: PreSelectInfo?.leadId,
      unitId: mergeIdData ? mergeID : unitNo,
      userId: loggedInUser?.userId,
      launchId: launchId,
      eventId: eventID,
      unitCost: {
        bsp: csvUploaded
          ? mergeIdData
            ? parseFloat(TotalBsp?.BSP) + parseFloat(TotalBsp?.BSP)
            : parseFloat(TotalBsp?.BSP)
          : mergeIdData
            ? parseFloat(TotalBsp?.BSPTotal) + parseFloat(TotalBsp?.BSPTotal)
            : parseFloat(TotalBsp?.BSPTotal),
        sdr: mergeIdData
          ? parseFloat(TotalBsp?.SDR) + parseFloat(TotalBsp?.SDR)
          : parseFloat(TotalBsp?.SDR),
        gst: mergeIdData
          ? parseFloat(TotalBsp?.GST) + parseFloat(TotalBsp?.GST)
          : parseFloat(TotalBsp?.GST),
        total: csvUploaded
          ? mergeIdData
            ? parseFloat(
              TotalBsp?.totalCost + TotalBsp?.totalCost
              // + FloorRiseValue
            )
            : parseFloat(TotalBsp?.totalCost
              // + FloorRiseValue
            )
          : mergeIdData
            ? parseFloat(TotalBsp?.Total + TotalBsp?.Total
              //  + FloorRiseValue
            )
            : parseFloat(TotalBsp?.Total
              // + FloorRiseValue
            ),
      },
      bookingAmt: {
        ocr: BookingAmountData[0].OCR,
        sdr: BookingAmountData[0].SDR,
        gst: BookingAmountData[0].GST,
        total: BookingAmountData[0].TOTAL,
      },
      paymentPlan: {
        ...selectedProjectPaymentPlan,
      },
      paymentId: null,
      pricingType: "preselect",
      paidAmount: PreSelectInfo?.paymentIdData?.paidAmount
        ? PreSelectInfo?.paymentIdData?.paidAmount
        : 0,
      inventoryMergedId: mergeIdData === true ? mergeID : null,
      preselectConfirmation: "payment pending",
      status:
        PreSelectInfo?.paymentIdData?.paidAmount > 0 &&
          PreSelectInfo?.paymentIdData?.paidAmount <
          PreSelectInfo?.selectedEventToken.tokenId.amount
          ? "Partial Payment Done"
          : PreSelectInfo?.paymentIdData?.paidAmount ===
            PreSelectInfo?.selectedEventToken.tokenId.amount
            ? "Payment Complete"
            : "Preselected", // ! changed
      // status: "On Hold", // ! to change this? @mayur
    };
    let todaysDate = getTodayDate();
    let PreSelectObj = {
      eventTokenId: PreSelectInfo?.selectedEventToken?.eventTokenId,
      leadId: PreSelectInfo?.leadId,
      eventId: PreSelectInfo?.selectedEventToken.eventId,
      amount: PreSelectInfo?.selectedEventToken.amount,
      paidAmount: PreSelectInfo?.paymentIdData?.paidAmount ? PreSelectInfo?.paymentIdData?.paidAmount : 0,
      tokenNumber: PreSelectInfo.selectedEventToken.tokenId.shortCode + '-' + todaysDate + '-' + Math.floor(1000 + Math.random() * 9000),
      status: 'alloted',
    };

    let unitStatusObj = [
      {
        StatusId: PreSelectInventoryStatus,
        unitId: mergeIdData ? mergeID : unitNo,
        leadId: PreSelectInfo?.leadId,
        UnitHoldTime: new Date().getTime(),
      },
    ];
    if (BookingAmountData[0].OCR) {
      allotUnit(
        AllotmentPreSelectDetails,
        unitStatusObj,
        null,
        PreSelectInfo?.selectedEventToken.eventId,
        UnitData,
        loggedInUser,
        PreSelectInfo?.paymentIdData?.paidAmount > 0 &&
          PreSelectInfo?.paymentIdData?.paidAmount <
          PreSelectInfo?.selectedEventToken.tokenId.amount
          ? "PreSelect Partial Payment Done"
          : PreSelectInfo?.paymentIdData?.paidAmount ===
            PreSelectInfo?.selectedEventToken.tokenId.amount
            ? "PreSelect Confirmation Pending"
            : "PreSelect Unit On Hold",
        PreSelectObj
      )
        .then(async (preselectResp) => {
          if (preselectResp?.data?.success) {
            // ! not needed as adjustToken called from 'allotUnit' api itself
            // await autoAdjustToken(preselectResp?.data?.allotmentPaymentId)
            successTost(
              `PreSelected Unit ${UnitData[0]?.wingId?.wingName} - ${UnitData[0]?.unitNo
              } for ${PreSelectInfo?.leadname
              }(VJ${PreSelectInfo?.leaddisplayid.replace(
                PreSelectInfo?.leaddisplayid.substring(8, 12),
                "-" + PreSelectInfo?.leaddisplayid.substring(8, 12)
              )})`
            );
            dismissLoader();
            getUnitData();
            navigate(-1);
          }
        })
        .catch((allotUnitError) => {
          dismissLoader();
          handleClose();
          if (
            allotUnitError?.response.data.error &&
            typeof allotUnitError?.response.data.error === "string"
          ) {
            errorTost(allotUnitError?.response?.data?.error);
          } else {
            errorTost("Something went wrong! Try again");
          }
        });
    } else {
      errorTost("Booking Amount not added, contact your admin.");
    }
  }

  function PaymentDetails() {
    if (SameUser === true) {
    } else {
      console.info('oh, first time');
      //*case 1 :payment button : allow
      getLeadDetailsFromInventory(unitNo)
        .then((response88) => {
          console.info('Inventory-Table-Data-->', response88.data[0].leadId); //* check lead is added in inventory Table
          //*check lead is added to inventory table
          getUnitStatus(unitNo)
            .then((response6) => {
              console.info("Unit-Data", response6);
              // ! vedashree changes for pbc event preselect rebooking
              const isPaymentTab = sessionStorage.getItem('isPaymentTab')
              console.log("isPaymentTab =====> ", isPaymentTab);
              getSelectedToken(LeadID, eventID, isPaymentTab ? isPaymentTab : false)
                .then((response) => {
                  console.log('Token-List ==========> ', response.data);
                  //*case 1: not added to inventory Table & unit is available & has tokens, put unit Status : on Hold
                  if (
                    response88.data[0].leadId === null &&
                    response6[0].InventoryStatus.status === 'Available' &&
                    response.count > 0
                  ) {
                    handleOpen();
                    // ? check inventoryType for priority pass tokens only
                    const applicableTokens = response.data.filter((token) => {
                      if (token.eventTokenId.tokenId.isPriorityPass) {
                        if (
                          token.eventTokenId.tokenId.inventoryTypeId ===
                          response6[0]?.inventoryTypeId
                        ) {
                          return token;
                        }
                      } else {
                        return token;
                      }
                    });
                    // ! to not restrict on inventoryType
                    // setTokenList(applicableTokens);
                    setTokenList(response.data);

                    //* case 2: not added to inventory Table & unit is on hold & has tokens , ask him to wait unit : available
                  } else if (response88.data[0].leadId !== null &&
                    response6[0].InventoryStatus.status === 'Available'
                  ) {
                    errorTost("Cannot allot unit. Contact your admin!")
                  } else if (
                    response88.data[0].leadId === null &&
                    response6[0].InventoryStatus.status === 'On Hold' &&
                    response.count > 0
                  ) {
                    infoTost(
                      "This Unit is on hold , Please wait until it's available"
                    );
                    setDisabledInterest(false);
                    setInterestQueueTable(true);
                  }
                })
                .catch((err) => {
                  console.error('Token-List', err);
                });
            })
            .catch((err) => {
              console.error('Unit-Data', err);
            });
        })
        .catch((err) => {
          console.error('Inventory-Table-Data', err);
        });
    }
  }

  function ValidateOnHoldData() {
    var form = true;
    if (TokenData.token === '') {
      form = false;
      setTokenHelperText((pre) => {
        pre.token = 'Please select Token';
        return { ...pre };
      });
    }

    return {
      flag: form,
    };
  }
 async function NumberOfBookingsAllowedCheck(paymentId) {
    // call RPC to check number of bookings allowed per token
      // Assuming you have already initialized Supabase
      console.log('Calling RPC with paymentId:', paymentId);
      const { data, error } = await supabase.rpc("get_number_of_bookings_allowed", {
        payment_id: paymentId
      });

      // Handling response
      if (error) {
        console.error('Error calling RPC:', error);
        errorTost('Error checking number of bookings allowed. Please try again later.');
        return false;
      } else {
        console.log('Response from RPC:', data);
        if (data && data?.length > 0) {
          // const { paymentId, allotment_count } = data[0];
          // console.log(`Payment ID: ${paymentId}, Allotment Count: ${allotment_count}`);
          return true;
        } else {
          console.log('No records found for the given paymentId.');
          errorTost('Number of bookings allowed for this token has been exceeded.');
          return false;
        }
      }
 }

 async function OnSubmitWrapper(data) {

   if (TokenList?.length === 1) {
      setTokenData((pre) => {
        pre.token = TokenList[0].paymentId;
        console.log('value', TokenList[0].paymentId);
        return { ...pre };
      });
    }
  console.log('NumberOfBookingsAllowedCheck called with TokenData:', TokenData);

  const isAllowed = await NumberOfBookingsAllowedCheck(TokenData?.token);
  if (isAllowed) {
     OnSubmit(data);
  }else{
    console.log('Booking not allowed for this token');
    return
  }
 }

  function OnSubmit(data) {
    console.log('Button-clicked data==========>', data);
    
    // if (TokenList?.length === 1) {
    //   setTokenData((pre) => {
    //     pre.token = TokenList[0].paymentId;
    //     console.log('value', TokenList[0].paymentId);
    //     return { ...pre };
    //   });
    // }

    let flag = ValidateOnHoldData();
  
    //*case 1: put the Unit On Hold
    if (flag.flag) {
      console.log("flag.flag ============> ", flag.flag);
      PutTheUnitOnHold(data);
                      console.log('setPaymentDetailsButton999');

      setPaymentDetailsButton(true);
    }
  }

  //*Add-Lead-UnitInterest-Table
  function ShowInterestByLeadName() {
    console.info('leadid', LeadID);
    console.info('unitId', unitNo);
    console.info('launchid', launchId);

    let InterestData = {
      leadId: LeadID,
      unitId: unitNo,
      launchId: launchId,
    };

    AddUnitInterest(InterestData)
      .then((response) => {
        console.info('Update-Interest-Data', response);
        successTost(`${LeadData[0].LeadName} has shown interest successfully`);
        UnitDetails(false);
        setDisabledInterest(true);
                      console.log('setPaymentDetailsButton888');

        setPaymentDetailsButton(true);
      })
      .catch((err) => {
        console.error('Update-Interest-Data-LeadName', err);
      });
  }

  function UnitDetails(merge) {
    getAllUnitInterests(
      unitNo,
      pageNumber * pageSize,
      pageNumber * pageSize + pageSize - 1
    )
      .then((res) => {
        console.info('All-Unit-Interests', res);
        const UnitData = res.data.map((el, index) => ({
          ...el,
          id: el.unitInterestId,
          index: index,
        }));

        if (merge) {
          setUnitInterestData((pre) => [...pre, ...UnitData]);
        } else {
          setUnitInterestData([...UnitData]);
        }
        console.log({ UnitData });
      })
      .catch((err) => {
        console.error('Unit-Interests-table-err', err);
      });
  }

  const ProjectColumns = [
    {
      field: 'id',
      headerName: '',
      width: 20,
      renderCell: (params) => {
        return <Box>{params.row.index + 1}</Box>;
      },
    },
    {
      field: 'TimeStamp',
      headerName: 'Time Stamp',
      width: 190,
      renderCell: (params) => {
        return (
          <Box>
            {new Date(params.row.created_at).toDateString()},{' '}
            {new Date(params.row.created_at).toLocaleTimeString([], {
              hour: '2-digit',
              minute: '2-digit',
            })}
          </Box>
        );
      },
    },
    {
      field: 'LeadName',
      headerName: 'Lead Name',
      width: 200,
      renderCell: (params) => {
        return (
          <Box>
            {params?.row?.leadId?.personId?.name
              ? params?.row?.leadId?.personId?.name
              : '-'}
          </Box>
        );
      },
    },
    {
      field: 'SalesRepresentative',
      headerName: 'Sales Representative',
      width: 190,
      renderCell: (params) => {
        return (
          <Box>
            {params?.row?.leadId?.userId?.name
              ? params?.row?.leadId?.userId?.name
              : '-'}
          </Box>
        );
      },
    },
    {
      field: 'action',
      headerName: 'Action',
      width: 70,
      renderCell: (params) => {
        return (
          <ThreeDotsMenu
            list={['remove']}
            selectedValue={(_value) => {
              selectedOption(params.row);
            }}
          />
        );
      },
    },
  ];

  //*Delete-Lead-from-Unit-Interest-Table
  function selectedOption(data) {
    console.log(data.leadId.personId.name);
    if (data !== '') {
      console.info('Unit-interest-Id', data?.unitInterestId);
      RemoveLeadFromInterestQueue(data?.unitInterestId)
        .then((res) => {
          console.info('SuccessFully Removed', res);
          UnitDetails(false);
          successTost(
            `${data?.leadId?.personId?.name} has been successFully removed!`
          );
        })
        .catch((err) => {
          errorTost('Something went wrong! try again');
          console.error('unit-remove-err', err);
        });
    }
  }

  function numberWithCommas(x) {
    return x?.toString().replace(/\B(?=(?:(\d\d)+(\d)(?!\d))+(?!\d))/g, ',');
  }
  return (
    <>
      {openPaymentModal === false && (
        <>
          <Box className={cssClasses.Container}>
            <>
              <Box
                margin={'2rem'}
                className={cssClasses.SearchDiv1}
                style={{ justifyContent: 'space-between' }}
              >
                <Box width={'calc(40% - 1rem)'}>
                  <Box className={cssClasses.headerTitle1}>
                    {ProjectData[0]?.projectName}
                  </Box>
                  <Box className={cssClasses.subTitle} mt={1}>
                    {ProjectData[0]?.addressLine1},{' '}
                    {ProjectData[0]?.addressLine2}{' '}
                    {ProjectData[0]?.addressLine3}
                  </Box>
                </Box>
                <Box className={cssClasses.unitDetails}>
                  {mergeIdData ? (
                    <Box className={cssClasses.headerTitle1} ml={1}>
                      {UnitData[0]?.wingId?.displayName
                        ? UnitData[0]?.wingId?.displayName
                        : UnitData[0]?.wingId?.wingName}
                      -
                      {UnitData[0]?.inventoryMergeId?.unit1No <
                        UnitData[0]?.inventoryMergeId?.unit2No
                        ? `${UnitData[0]?.inventoryMergeId?.unit1No} , ${UnitData[0]?.inventoryMergeId?.unit2No}`
                        : `${UnitData[0]?.inventoryMergeId?.unit2No} , ${UnitData[0]?.inventoryMergeId?.unit1No}`}
                      <Box className={cssClasses.subTitle} mt={1}>
                        {ProjectData[0]?.displayInventoryType?.includes(
                          'Inventory Type'
                        )
                          ? UnitData[0]?.inventoryTypeId?.type
                          : ''}
                        {ProjectData[0]?.displayInventoryType?.includes(
                          'Display Unit Type'
                        ) && '(' + UnitData[0]?.displayUnitType + ')'}
                      </Box>
                    </Box>
                  ) : (
                    <>
                      <Box className={cssClasses.headerTitle1} ml={1}>
                        {UnitData[0]?.wingId?.displayName
                          ? UnitData[0]?.wingId?.displayName
                          : UnitData[0]?.wingId?.wingName}
                        -{UnitData[0]?.unitNo}
                        <Box className={cssClasses.subTitle} mt={1}>
                          {ProjectData[0]?.displayInventoryType?.includes(
                            'Inventory Type'
                          )
                            ? UnitData[0]?.inventoryTypeId?.type
                            : ''}
                          {ProjectData[0]?.displayInventoryType?.includes(
                            'Display Unit Type'
                          ) &&
                            UnitData[0]?.displayUnitType !== null &&
                            '(' + UnitData[0]?.displayUnitType + ')'}
                        </Box>
                      </Box>
                    </>
                  )}
                  <Box className={cssClasses.subTitle} mt={1}>
                    <LeadStatusChip
                      style={{
                        color: ChipStyle?.chipColor,
                        backgroundColor: ChipStyle?.chipBackgroundColor,
                      }}
                      label={
                        ProjectPricingDetails[0]?.inventoryStatusId?.status
                      }
                      icon={<Dot width={'0.6rem'} height={'0.6rem'} />}
                    />
                  </Box>
                </Box>
              </Box>
            </>

            <>
              <Box height={'100%'} overflow={'auto'}>
                {/* Adding Dropdown for Pricing */}
                <Box className={cssClasses.wrapperDropDownAndPrices}>
                  {PreSelectedLead === false ? (
                    <>
                      {priceNotAdded === false ? (
                        <>
                          {' '}
                          {!ProjectData[0]?.csvUploaded && (
                            <Box className={cssClasses.wrapperDropDown}>
                              <div className={cssClasses.dropDown}>
                                <DropDown
                                  list={listOfProjectPricing.map(
                                    (element, id) => {
                                      return {
                                        label: element.projectPricingId.title,
                                        value: element.projectPricingId.title,
                                      };
                                    }
                                  )}
                                  selectedValue={selectedProjectPricingTitle}
                                  onChangeSelect={(value) => {
                                    setSelectedProjectPricingTitle(value);
                                    let selectedProjectPricing =
                                      listOfProjectPricing.filter(
                                        (el) =>
                                          value === el.projectPricingId.title
                                      );
                                    checkInBasePriceList(
                                      selectedProjectPricing[0]
                                    );
                                  }}
                                  placeHolder={''}
                                  style={{
                                    background: '#F2F4F7',
                                    color: 'rgb(102, 112, 133)',
                                  }}
                                />
                              </div>
                            </Box>
                          )}
                          <Box>
                            <Box className={cssClasses.subTitle}>
                              Saleable Area of Unit:
                            </Box>
                            <Box className={cssClasses.headerTitle1} mt={1}>
                              {saleableArea
                                ? numberWithCommas(saleableArea)
                                : '-'}
                              Sqft
                            </Box>
                          </Box>
                          <Box>
                            <Box className={cssClasses.subTitle}>
                              Agreement Value:
                            </Box>
                            {mergeIdData ? (
                              <Box className={cssClasses.headerTitle1} mt={1}>
                                ₹
                                {csvUploaded
                                  ? TotalBsp?.BSP
                                    ? numberWithCommas(
                                      parseFloat(TotalBsp?.BSP) +
                                      parseFloat(TotalBsp?.BSP)
                                    )
                                    : '-'
                                  : TotalBsp?.BSPTotal
                                    ? numberWithCommas(
                                      parseFloat(TotalBsp?.BSPTotal) +
                                      parseFloat(TotalBsp?.BSPTotal)
                                    )
                                    : ''}
                              </Box>
                            ) : (
                              <Box className={cssClasses.headerTitle1} mt={1}>
                                ₹{' '}
                                {csvUploaded
                                  ? TotalBsp?.BSP
                                    ? numberWithCommas(TotalBsp?.BSP)
                                    : '-'
                                  : TotalBsp?.BSP
                                    ? numberWithCommas(TotalBsp?.BSPTotal)
                                    : '-'}
                              </Box>
                            )}
                          </Box>
                          <Box>
                            <Box className={cssClasses.subTitle}>GST:</Box>
                            {mergeIdData ? (
                              <Box className={cssClasses.headerTitle1} mt={1}>
                                ₹{' '}
                                {TotalBsp?.GST
                                  ? numberWithCommas(
                                    parseFloat(TotalBsp?.GST) +
                                    parseFloat(TotalBsp?.GST)
                                  )
                                  : '-'}
                              </Box>
                            ) : (
                              <Box className={cssClasses.headerTitle1} mt={1}>
                                ₹{' '}
                                {TotalBsp?.GST
                                  ? numberWithCommas(TotalBsp?.GST)
                                  : '-'}
                              </Box>
                            )}
                          </Box>
                          {/* <Box>
                    <Box className={cssClasses.subTitle}>Reg:</Box>
                    <Box className={cssClasses.headerTitle1} mt={1}>
                      ₹ {TotalBsp?.REG ? numberWithCommas(TotalBsp?.REG) : "-"}
                    </Box>
                  </Box> */}
                          <Box>
                            <Box className={cssClasses.subTitle}>SDR:</Box>
                            {mergeIdData ? (
                              <Box className={cssClasses.headerTitle1} mt={1}>
                                ₹{' '}
                                {TotalBsp?.SDR
                                  ? numberWithCommas(
                                    parseFloat(TotalBsp?.SDR) +
                                    parseFloat(TotalBsp?.SDR)
                                  )
                                  : '-'}
                              </Box>
                            ) : (
                              <Box className={cssClasses.headerTitle1} mt={1}>
                                ₹{' '}
                                {TotalBsp?.SDR
                                  ? numberWithCommas(TotalBsp?.SDR)
                                  : '-'}
                              </Box>
                            )}
                          </Box>
                          {/* <Box>
                    <Box className={cssClasses.subTitle}>FloorRise:</Box>
                    {mergeIdData ? (
                      <Box className={cssClasses.headerTitle1} mt={1}>
                        ₹{FloorRiseValue ? numberWithCommas(FloorRiseValue) : "00.00"}
                      </Box>
                    ) : (
                      <Box className={cssClasses.headerTitle1} mt={1}>
                        ₹{FloorRiseValue ? numberWithCommas(FloorRiseValue) : "00.00"}
                      </Box>
                    )}
                  </Box> */}
                          {/* <Box>
                  <Box className={cssClasses.subTitle}>Plc:</Box>
                  {mergeIdData ? (
                    <Box className={cssClasses.headerTitle1} mt={1}>
                      ₹{plcValue ? numberWithCommas(plcValue) : "-"}
                    </Box>
                  ) : (
                    <Box className={cssClasses.headerTitle1} mt={1}>
                      ₹{plcValue ? numberWithCommas(plcValue) : "-"}
                    </Box>
                  )}
                </Box> */}
                          <Box>
                            <Box className={cssClasses.subTitle}>Total:</Box>
                            {mergeIdData ? (
                              <Box className={cssClasses.headerTitle1} mt={1}>
                                ₹
                                {csvUploaded
                                  ? TotalBsp?.totalCost
                                    ? numberWithCommas(
                                      (
                                        parseFloat(TotalBsp?.totalCost)
                                        // parseFloat(FloorRiseValue) +
                                        // parseFloat(plcValue)
                                      )
                                    )
                                    : '-'
                                  : TotalBsp?.Total
                                    ? numberWithCommas(
                                      (
                                        parseFloat(TotalBsp?.Total) +
                                        parseFloat(TotalBsp?.Total)
                                        // parseFloat(FloorRiseValue) +
                                        // parseFloat(plcValue)
                                      ).toFixed(2)
                                    )
                                    : '-'}
                              </Box>
                            ) : (
                              <Box className={cssClasses.headerTitle1} mt={1}>
                                ₹
                                {csvUploaded
                                  ? TotalBsp?.totalCost
                                    ? numberWithCommas(
                                      (
                                        parseFloat(TotalBsp?.totalCost)
                                        // FloorRiseValue +
                                        // plcValue
                                      ).toFixed(2)
                                    )
                                    : '-'
                                  : TotalBsp?.Total
                                    ? numberWithCommas(
                                      (
                                        parseFloat(TotalBsp?.Total)
                                        // parseFloat(FloorRiseValue) +
                                        // parseFloat(plcValue)
                                      ).toFixed(2)
                                    )
                                    : '-'}
                              </Box>
                            )}
                          </Box>
                        </>
                      ) : (
                        <>
                          <Box ml={1.8}>
                            <Box className={cssClasses.subTitle}>
                              Saleable Area of Unit:
                            </Box>
                            <Box className={cssClasses.headerTitle1} mt={1}>
                              {saleableArea
                                ? numberWithCommas(saleableArea)
                                : '-'}{' '}
                              Sq.Ft.
                            </Box>
                          </Box>

                          <Box
                            className={cssClasses.headerTitle1}
                            ml={2}
                            display={'flex'}
                            flexDirection={'row'}
                          >
                            <LeadStatusChip
                              style={{
                                color: '#000000',
                                backgroundColor: '#ececec',
                              }}
                              label={'Price not Added!'}
                              icon={<Dot width={'0.6rem'} height={'0.6rem'} />}
                            />
                            {afterCancelUnitPrice && (
                              <Box mt={0.2} ml={1}>
                                <InfoOutlinedIcon
                                  onClick={handleClick}
                                  style={{
                                    width: '2rem',
                                    height: '2rem',
                                    color: '#344054',
                                  }}
                                ></InfoOutlinedIcon>
                                <Popover
                                  id={id}
                                  open={IconOpen}
                                  anchorEl={anchorEl}
                                  onClose={handleIconClose}
                                  anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'right',
                                  }}
                                >
                                  <Typography
                                    style={{ fontSize: '1.4rem' }}
                                    sx={{ p: 2 }}
                                  >
                                    Unit is recently cancelled.Reprice is
                                    pending
                                  </Typography>
                                </Popover>
                              </Box>
                            )}
                          </Box>
                        </>
                      )}
                    </>
                  ) : (
                    <>
                      <Box ml={1.8}>
                        <Box className={cssClasses.subTitle}>
                          Saleable Area of Unit:
                        </Box>
                        <Box className={cssClasses.headerTitle1} mt={1}>
                          {saleableArea ? numberWithCommas(saleableArea) : '-'}{' '}
                          Sq.Ft.
                        </Box>
                      </Box>
                    </>
                  )}
                </Box>
                {ProjectData[0]?.enablePaymentPlan && listOfProjectPaymentPlan.length > 0 && (
                  <Box className={cssClasses.wrapperDropDown} padding={"2rem"} width={"60rem"}>
                    <div className={cssClasses.SubHeader}>
                      Select Payment Plan
                    </div>
                    <div style={{ width: '60%' }}>
                      <DropDown
                        list={listOfProjectPaymentPlan.map((element, id) => {
                          return {
                            label: element?.title,
                            value: element?.title,
                          };
                        })}
                        selectedValue={selectedProjectPaymentPlanId}
                        onChangeSelect={(value) => {
                          setSelectedProjectPaymentPlanId(value);
                          let selectedProjectPricing =
                            listOfProjectPaymentPlan.filter(
                              (el) => value === el.title
                            );
                          setSelectedProjectPaymentPlan(
                            selectedProjectPricing[0]
                          );
                          presentLoader()
                          if (selectedProjectPricing[0]?.title === 'none') {
                            checkForInventoryStatus(unitNo).then(resp => {
                              const payload = { ...TotalBsp }
                              payload.BSP = resp?.data?.BSP
                              payload.GST = resp?.data?.GST
                              payload.SDR = resp?.data?.SDR
                              payload.totalCost = resp?.data?.totalCost
                              setTotalBsp(payload)
                              dismissLoader()
                            }).catch(err => {
                              dismissLoader()
                            })
                          } else {
                            getPaymentPlansPriceFromServer(selectedProjectPricing[0]?.paymentPlanId, unitNo).then((resp) => {
                              const payload = { ...TotalBsp }
                              if (resp?.data?.length > 0) {
                                payload.BSP = resp?.data[0]?.BSP
                                payload.GST = resp?.data[0]?.GST
                                payload.SDR = resp?.data[0]?.SDR
                                payload.totalCost = resp?.data[0]?.totalCost
                              }
                              setTotalBsp(payload)
                              dismissLoader()
                            }).catch(err => {
                              dismissLoader()
                            })
                          }
                        }}
                        placeHolder={'Select Payment Plan'}
                        style={{
                          background: '#F2F4F7',
                          color: 'rgb(102, 112, 133)',
                        }}
                      />
                    </div>
                  </Box>
                )}
                <Box className={cssClasses.SearchDiv} style={{ height: '90%' }}>
                  {!OnHoldData && (
                    <Box style={{ width: '50%' }}>
                      {globalLead === false && PreSelectedLead === false && (
                        <Box margin={'2rem'}>
                          <Box
                            className={cssClasses.headerTitle}
                            marginBottom={'2.4rem'}
                          >
                            Select Lead
                          </Box>
                          {/* {OnHoldData === true && (
                          <Box>
                            <Box
                              className={cssClasses.DetailsDiv}
                              margin={"3rem 0rem"}
                            >
                              <Box className={cssClasses.SearchDiv}>
                                <Box>
                                  <Box
                                    className={cssClasses.NameTitle}
                                    
                                  >
                                    {OnHoldDetails[0]?.Name}
                                  </Box>
                                  <Box className={cssClasses.NoTitle}>
                                    VJ
                                    {OnHoldDetails[0]?.DisplayId}
                                  </Box>
                                  <Box
                                    className={cssClasses.PhoneNumberTitle}
                                    mt={1}
                                  >
                                    +{OnHoldDetails[0]?.MobileNumber}
                                  </Box>
                                  <Box
                                    className={cssClasses.PhoneNumberTitle}
                                   
                                  >
                                    {OnHoldDetails[0]?.Email}
                                  </Box>
                                </Box>
                              </Box>
                            </Box>
                          </Box>
                        )} */}
                          <Box className={cssClasses.SearchDiv}>
                            <Box className={cssClasses.InputDiv}>
                              <Box className={cssClasses.subTitle}>
                                Search Lead ID or Lead Name
                              </Box>
                              <Box width={'35rem'}>
                                <CustomAutoComplete
                                  value={LeadValue}
                                  InitialValue={setLeadValue}
                                  SecondInputValue={LeadName}
                                  OnInputChange={(e, inputValue) => {
                                    console.log('InputValue =====>', inputValue);
                                    setAllotmentData((pre) => {
                                      pre.displayName = inputValue;
                                      SearchDataInLeads(inputValue);
                                      return { ...pre };
                                    });

                                    if (AllotmentData.displayName !== '') {
                                      helperText.displayName = '';
                                    } else {
                                      helperText.displayName =
                                        'Please select Lead';
                                    }
                                  }}
                                  disable={false}
                                  list={AllLeads.map((m) => ({
                                    label: `${m.LeadName} - ${m.LeadDisplayId}`,
                                  }))}
                                  NoOptionsText={'No Leads Found'}
                                  getOptionLabel={(lead) => lead.label || ''}
                                  renderOption={(props, SecondInputValue) => (
                                    <Fragment>
                                      <li {...props} key={SecondInputValue.id}>
                                        <span
                                          className={cssClasses.textWrapper}
                                          style={{
                                            overflow: 'hidden',
                                            whiteSpace: 'break-spaces',
                                          }}
                                        >
                                          {SecondInputValue.label}
                                        </span>
                                      </li>
                                    </Fragment>
                                  )}
                                  helperText={helperText.displayName}
                                />
                              </Box>
                            </Box>
                          </Box>
                        </Box>
                      )}

                      {globalLead === true && (
                        <Box marginTop={'7.5rem'}>
                          <Box margin={'2rem'}>
                            <Box
                              className={cssClasses.headerTitle}
                              marginBottom={'2.4rem'}
                            >
                              Lead Details
                            </Box>
                          </Box>
                          {LeadData?.map((lead, _index) => (
                            <Box m={2}>
                              <Box
                                className={cssClasses.DetailsDiv}
                                margin={'2rem'}
                                style={{ cursor: 'pointer' }}
                              >
                                <Box className={cssClasses.SearchDiv}>
                                  <Box>
                                    <Box className={cssClasses.NameTitle}>
                                      {lead.LeadName}
                                    </Box>
                                    <Box className={cssClasses.NoTitle}>
                                      VJ
                                      {lead.LeadDisplayId}
                                    </Box>
                                    {loggedInUser.roleId.level === 1 && (
                                      <>
                                        <Box
                                          className={
                                            cssClasses.PhoneNumberTitle
                                          }
                                          mt={1}
                                        >
                                          +{lead.LeadMobileNumber}
                                        </Box>
                                        <Box
                                          className={
                                            cssClasses.PhoneNumberTitle
                                          }
                                        >
                                          {lead.LeadEmail}
                                        </Box>
                                      </>
                                    )}
                                  </Box>
                                </Box>
                              </Box>
                            </Box>
                          ))}
                        </Box>
                      )}

                      {/* Sarita's Adding adjust Unit Amount Starts Here*/}
                      {globalLead === true &&
                        getAlotEventLead()?.oldAllotmentData &&
                        ProjectPricingDetails[0]?.inventoryStatusId?.status ===
                        'Available' && (
                          <Box
                            marginTop={'7.5rem'}
                            className={cssClasses.wrapperSummary}
                          >
                            <Box margin={'2rem'}>
                              <Box
                                className={cssClasses.headerTitle}
                                marginBottom={'2.4rem'}
                              >
                                Summary
                              </Box>
                            </Box>
                            <Box m={2} className={cssClasses.wrapperEachDiv}>
                              <div>
                                <div
                                  className={cssClasses.PhoneNumberTitle}
                                  style={{
                                    fontFamily: 'Inter-Medium',
                                    lineHeight: '1.8rem',
                                    textAlign: 'left',
                                    color: '#1D2939',
                                    fontWeight: '600',
                                    marginBottom: '0.5rem',
                                  }}
                                >
                                  {/* {getAlotEventLead()?.oldAllotmentData?.projectname},{getAlotEventLead()?.oldAllotmentData?.wingname}-{getAlotEventLead()?.oldAllotmentData?.unitno}
                                   */}
                                  {
                                    getAlotEventLead()?.oldAllotmentData
                                      ?.projectname
                                  }
                                  ,
                                  {
                                    getAlotEventLead()?.oldAllotmentData
                                      ?.displaywingname
                                  }
                                  -
                                  {getAlotEventLead()?.oldAllotmentData?.unitno}
                                </div>

                                <div
                                  style={{
                                    fontSize: '1.6rem',
                                    fontFamily: 'Inter-Medium',
                                    lineHeight: '2.4rem',
                                    width: '50%',
                                    textAlign: 'left',
                                    color: '#344054',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                  }}
                                >
                                  <span>Balance Amount:</span>
                                  <span style={{ color: '#374151' }}>
                                    ₹
                                    {numberWithCommas(
                                      getAlotEventLead()?.oldAllotmentData
                                        ?.paidamount
                                    )}
                                  </span>
                                </div>
                              </div>
                              {/* <div  className={cssClasses.PhoneNumberTitle}>New Amount: */}
                              {BookingAmountData[0]?.TOTAL && (
                                <Box
                                  className={cssClasses.PhoneNumberTitle}
                                  mt={1}
                                >
                                  <div
                                    className={cssClasses.PhoneNumberTitle}
                                    style={{
                                      fontFamily: 'Inter-Medium',
                                      lineHeight: '1.8rem',
                                      textAlign: 'left',
                                      color: '#1D2939',
                                      fontWeight: '600',
                                      marginBottom: '0.5rem',
                                    }}
                                  >
                                    {ProjectData[0]?.projectName},
                                    {UnitData[0]?.wingId?.displayName
                                      ? UnitData[0]?.wingId?.displayName
                                      : UnitData[0]?.wingId?.wingName}
                                    -{UnitData[0]?.unitNo}
                                    {/* {ProjectData[0]?.projectName},{UnitData[0]?.wingId?.wingName}-{UnitData[0]?.unitNo} */}
                                  </div>
                                  <div
                                    style={{
                                      fontSize: '1.6rem',
                                      fontFamily: 'Inter-Medium',
                                      lineHeight: '2.4rem',
                                      width: '50%',
                                      textAlign: 'left',
                                      color: '#344054',
                                      display: 'flex',
                                      justifyContent: 'space-between',
                                    }}
                                  >
                                    <span>Booking Amount:</span>
                                    <span style={{ color: '#374151' }}>
                                      ₹
                                      {numberWithCommas(
                                        BookingAmountData[0]?.TOTAL
                                      )}
                                    </span>
                                  </div>
                                </Box>
                              )}

                              {/* </div> */}
                              {/* {getAlotEventLead()?.oldAllotmentData
                                ?.paidamount <= BookingAmountData[0]?.TOTAL && (
                                <div
                                  className={cssClasses.PhoneNumberTitle}
                                  style={{ marginTop: "1rem" }}
                                >
                                  Difference Amount: ₹
                                  {numberWithCommas(
                                    BookingAmountData[0]?.TOTAL -
                                      getAlotEventLead()?.oldAllotmentData
                                        ?.paidamount
                                  )}
                                </div>
                              )} */}

                              {(getAlotEventLead()?.oldAllotmentData
                                ?.updatedunitprice && (getAlotEventLead()?.oldAllotmentData
                                  ?.updatedunitprice?.cancellationCharges !== 0 ||
                                  getAlotEventLead()?.oldAllotmentData
                                    ?.updatedunitprice != null)) && (
                                  <div
                                    className={cssClasses.PhoneNumberTitle}
                                    style={{
                                      fontFamily: 'Inter-Medium',
                                      lineHeight: '1.4rem',
                                      textAlign: 'left',
                                      color: '#344054',
                                      marginBottom: '0.5rem'
                                    }}
                                  >
                                    Cancellation Charges:₹
                                    {getAlotEventLead()?.oldAllotmentData
                                      ?.updatedunitprice?.cancellationCharges !==
                                      0
                                      ? numberWithCommas(
                                        getAlotEventLead()?.oldAllotmentData
                                          ?.updatedunitprice
                                          ?.cancellationCharges
                                      )
                                      : 0}
                                  </div>
                                )}
                              {getAlotEventLead()?.oldAllotmentData
                                ?.paidamount <= BookingAmountData[0]?.TOTAL ? (
                                <div
                                  className={cssClasses.PhoneNumberTitle}
                                  // style={{
                                  //   fontFamily: 'Inter-Medium',
                                  //   lineHeight: '1.4rem',
                                  //   textAlign: 'left',
                                  //   color: '#344054',
                                  //   marginBottom: '0.5rem'
                                  // }}
                                  style={{
                                    fontSize: '1.6rem',
                                    fontFamily: 'Inter-Medium',
                                    lineHeight: '2.4rem',
                                    width: '50%',
                                    textAlign: 'left',
                                    color: '#344054',
                                    display: 'flex',
                                    justifyContent: 'space-between'
                                  }}
                                >
                                  <span>
                                    Amount to be Paid:
                                  </span>
                                  <span style={{ color: '#374151' }}>
                                    ₹ {getAlotEventLead()?.oldAllotmentData
                                      ?.updatedunitprice ? (
                                      numberWithCommas(
                                        BookingAmountData[0]?.TOTAL -
                                        (getAlotEventLead()?.oldAllotmentData
                                          ?.paidamount -
                                          getAlotEventLead()?.oldAllotmentData
                                            ?.updatedunitprice
                                            ?.cancellationCharges)
                                      )) :
                                      numberWithCommas(
                                        BookingAmountData[0]?.TOTAL -
                                        (getAlotEventLead()?.oldAllotmentData
                                          ?.paidamount)
                                      )
                                    }
                                  </span>
                                </div>
                              ) : (
                                <>
                                  <div
                                    className={cssClasses.PhoneNumberTitle}
                                    style={{
                                      fontFamily: 'Inter-Medium',
                                      lineHeight: '1.4rem',
                                      textAlign: 'left',
                                      color: '#344054',
                                      marginBottom: '0.5rem',
                                    }}
                                  >
                                    {' '}
                                    Amount to be Paid:₹0
                                  </div>
                                  <div
                                    className={cssClasses.PhoneNumberTitle}
                                    style={{ marginTop: '1rem' }}
                                  >
                                    Note: Excess Amount to be adjusted in
                                    UnitCost
                                  </div>
                                </>
                              )}
                            </Box>
                          </Box>
                        )}
                      {/* {globalLead === true &&
                        ProjectPricingDetails[0]?.inventoryStatusId?.status==='Available'&&
                        errorMessageForAlotUnitAlreadyAlloted !== "" && (
                          <div
                            style={{ color: "red" }}
                            className={cssClasses.PhoneNumberTitle}
                          >
                            {errorMessageForAlotUnitAlreadyAlloted}
                          </div>
                        )} */}
                      {/* Sarita's Adding adjust Unit Amount Ends Here*/}

                      {PreSelectedLead === true && (
                        <Box marginTop={'7.5rem'}>
                          <Box margin={'2rem'}>
                            <Box
                              className={cssClasses.headerTitle}
                              marginBottom={'2.4rem'}
                            >
                              Lead Details
                            </Box>
                          </Box>
                          {LeadData?.map((lead, _index) => (
                            <Box m={2}>
                              <Box
                                className={cssClasses.DetailsDiv}
                                margin={'2rem'}
                                style={{ cursor: 'pointer' }}
                              >
                                <Box className={cssClasses.SearchDiv}>
                                  <Box>
                                    <Box className={cssClasses.NameTitle}>
                                      {lead.LeadName}
                                    </Box>
                                    <Box className={cssClasses.NoTitle}>
                                      VJ
                                      {lead.LeadDisplayId}
                                    </Box>
                                    {loggedInUser.roleId.level === 1 && (
                                      <>
                                        <Box
                                          className={
                                            cssClasses.PhoneNumberTitle
                                          }
                                          mt={1}
                                        >
                                          +{lead.LeadMobileNumber}
                                        </Box>
                                        <Box
                                          className={
                                            cssClasses.PhoneNumberTitle
                                          }
                                        >
                                          {lead.LeadEmail}
                                        </Box>
                                      </>
                                    )}
                                  </Box>
                                </Box>
                              </Box>
                            </Box>
                          ))}
                        </Box>
                      )}

                      {AllotmentData.displayName !== '' &&
                        globalLead === false &&
                        PreSelectedLead === false &&
                        OnHoldData === false && (
                          <Box>
                            {SameUser === false && (
                              <>
                                {LeadData?.map((lead, _index) => (
                                  <Box m={2}>
                                    <Box className={cssClasses.DetailsDiv}>
                                      <Box className={cssClasses.SearchDiv}>
                                        <Box>
                                          <Box className={cssClasses.NameTitle}>
                                            {lead.LeadName}
                                          </Box>
                                          <Box className={cssClasses.NoTitle}>
                                            VJ
                                            {lead.LeadDisplayId}
                                            {lead.LeadCheckpoint2}
                                          </Box>
                                          {loggedInUser.roleId.level === 1 && (
                                            <>
                                              <Box
                                                className={
                                                  cssClasses.PhoneNumberTitle
                                                }
                                                mt={1}
                                              >
                                                +{lead.LeadMobileNumber}
                                              </Box>
                                              <Box
                                                className={
                                                  cssClasses.PhoneNumberTitle
                                                }
                                              >
                                                {lead.LeadEmail}
                                              </Box>
                                            </>
                                          )}

                                          {CheckPt2Message && (
                                            <Box
                                              className={
                                                cssClasses.PhoneNumberTitle
                                              }
                                            >
                                              <LeadStatusChip
                                                style={{
                                                  color: '#B42318',
                                                  backgroundColor: '#FEE4E2',
                                                }}
                                                label={
                                                  'Checkpoint two not cleared'
                                                }
                                                icon={
                                                  <Dot
                                                    width={'0.6rem'}
                                                    height={'0.6rem'}
                                                  />
                                                }
                                              />
                                            </Box>
                                          )}

                                          {TokenMessage === true && (
                                            <Box
                                              component={'span'}
                                              ml={1}
                                              mt={0.5}
                                            >
                                              <LeadStatusChip
                                                style={{
                                                  color: '#000000',
                                                  backgroundColor: '#D1E9FF',
                                                }}
                                                label={'No Token Available'}
                                                icon={
                                                  <Dot
                                                    width={'0.6rem'}
                                                    height={'0.6rem'}
                                                  />
                                                }
                                              />
                                            </Box>
                                          )}
                                        </Box>
                                      </Box>
                                    </Box>
                                  </Box>
                                ))}
                              </>
                            )}
                          </Box>
                        )}

                      {/* {DisabledInterest === false && (
                      <Box width={"fit-content"} margin={"2rem"}>
                        <Button
                          style={{
                            fontSize: "1.6rem",
                            lineHeight: "2.4rem",
                            color: "#FFF",
                            backgroundColor: "#007FFF",
                          }}
                          padding={"0.8rem 1.8rem"}
                          // disable={DisabledInterest}
                          btnName={"Show Interest"}
                          clicked={ShowInterestByLeadName}
                        />
                      </Box>
                    )} */}
                    </Box>
                  )}
                  {OnHoldData === true && (
                    <Box style={{ width: '50%' }}>
                      <Box margin={'2rem'}>
                        <Box
                          className={cssClasses.headerTitle}
                          marginBottom={'2.4rem'}
                        >
                          Lead Details
                        </Box>
                        <Box
                          className={cssClasses.DetailsDiv}
                          margin={'3rem 0rem'}
                        >
                          <Box className={cssClasses.SearchDiv}>
                            <Box>
                              <Box className={cssClasses.NameTitle}>
                                {OnHoldDetails[0]?.Name}
                              </Box>
                              <Box className={cssClasses.NoTitle}>
                                VJ
                                {OnHoldDetails[0]?.DisplayId}
                              </Box>
                              {loggedInUser.roleId.level === 1 && (
                                <>
                                  <Box
                                    className={cssClasses.PhoneNumberTitle}
                                    mt={1}
                                  >
                                    +{OnHoldDetails[0]?.MobileNumber}
                                  </Box>
                                  <Box className={cssClasses.PhoneNumberTitle}>
                                    {OnHoldDetails[0]?.Email}
                                  </Box>
                                </>
                              )}
                            </Box>
                          </Box>
                        </Box>
                        <Box>
                          <Box
                            className={cssClasses.headerTitle}
                            marginBottom={'2.4rem'}
                          >
                            VJ SM
                          </Box>
                          <Box
                            className={cssClasses.DetailsDiv}
                            margin={'3rem 0'}
                          >
                            <Box className={cssClasses.NameTitle}>
                              {/* {AllotmentIdData[0]?.userId.name} */}
                              {AllotmentIdData[0]?.leadId?.userId?.name}
                            </Box>
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  )}
                  {/* {InterestQueueTable === true && (
                    <Box style={{ height: "100%", width: "50%" }}>
                      <Box style={{ width: "95%", height: "100%" }}>
                        <Box
                          className={cssClasses.subTitle}
                          marginTop={"7.5rem"}
                        >
                          Interest Queue for {UnitData[0]?.unitNo}
                        </Box>
                        <Box className={cssClasses.GridWrapper}>
                          <Datagrid
                            rows={UnitInterestData}
                            columns={ProjectColumns}
                            hideFooter={false}
                          />
                        </Box>
                      </Box>
                    </Box>
                  )} */}
                </Box>
              </Box>
            </>
          </Box>

          <>
            {PreSelectedLead === true && (
              <Box className={cssClasses.footerDiv}>
                <Box className={cssClasses.RightButtonWrap}>
                  <Box display={'flex'} flexDirection={'row'}>
                    {/* {PreSelectPayNow === false && ( */}
                    {/* // ! vedashree changes */}
                    {UnitData[0]?.inventoryStatusId.status === 'Available' && (
                      <Box width={'fit-Content'} mr={2}>
                        <Button
                          style={{
                            color: '#fff',
                            backgroundColor: '#1570EF',
                            fontSize: '1.4rem',
                            lineHeight: '2rem',
                            fontFamily: 'Roboto-Regular',
                          }}
                          disable={PreSelectPayNow === true}
                          padding={'0.8rem 2.6rem'}
                          btnName={'Confirm Preselect'}
                          clicked={() => PreSelectAllotment()}
                        />
                      </Box>
                    )}
                    {PreSelectPayNow === true && (
                      <Box width={'fit-Content'}>
                        <a
                          href={`https://wa.me/${phoneNumber}/?text=${WhatsAppMessage}?`}
                          data-action='share/whatsapp/share'
                          target='_blank'
                          rel='noopener noreferrer'
                          style={{ textDecoration: 'none' }}
                        >
                          <Button
                            style={{
                              fontSize: '1.6rem',
                              lineHeight: '2.4rem',
                              color: 'rgb(102, 112, 133)',
                              backgroundColor: '#FFF',
                              borderRadius: '0.8rem',
                            }}
                            padding={'0.8rem 2.6rem'}
                            btnName={'Share Payment Details'}
                            clicked={() =>
                              console.log('share details on whatsapp')
                            }
                            btnIcon={<WhatsappIcon size={32} round={true} />}
                            iconPosition={'left'}
                          // btnName={"Pay Now"}
                          // clicked={() => setOpenPaymentModal(true)}
                          />
                        </a>
                      </Box>
                    )}
                  </Box>
                </Box>
              </Box>
            )}
            {console.log('PreSelectedLead, priceNotAdded, SameUser  ', PreSelectedLead, priceNotAdded, SameUser)}
            {console.log('PaymentDetailsButton, CheckPt2Message, errorMessageForAlotUnitAlreadyAlloted  ', PaymentDetailsButton, CheckPt2Message, errorMessageForAlotUnitAlreadyAlloted )}
            {PreSelectedLead === false && priceNotAdded === false && (
              <Box className={cssClasses.footerDiv}>
                <Box className={cssClasses.RightButtonWrap}>
                  {SameUser === false && (
                    <Button
                      style={{
                        color: '#fff',
                        backgroundColor: '#1570EF',
                        fontSize: '1.4rem',
                        lineHeight: '2rem',
                        fontFamily: 'Roboto-Regular',
                      }}
                      padding={'0.8rem 2.6rem'}
                      disable={
                        PaymentDetailsButton ||
                        CheckPt2Message ||
                        errorMessageForAlotUnitAlreadyAlloted !== ''
                      }
                      btnName={'Confirm'}
                      clicked={() => PaymentDetails()}
                    />
                  )}

                  {SameUser && (
                    <Box width={'fit-Content'}>
                      <Button
                        style={{
                          color: '#fff',
                          backgroundColor: '#1570EF',
                          fontSize: '1.4rem',
                          lineHeight: '2rem',
                          fontFamily: 'Roboto-Regular',
                        }}
                        //  disable={unitStatus === ''}
                        padding={'0.65rem 2.5rem'}
                        btnName={'Pay Now'}
                        clicked={() => setOpenPaymentModal(true)}
                      />
                    </Box>
                  )}
                </Box>
              </Box>
            )}
          </>

          <Modal
            open={open}
            onClose={(_, reason) => {
              if (reason !== 'backdropClick') {
                handleClose();
              }
            }}
            aria-labelledby='modal-modal-title'
            aria-describedby='modal-modal-description'
          >
            <Box sx={style}>
              <Box className={cssClasses.headerDiv}>
                <Box className={cssClasses.flexRow}>
                  <Box className={cssClasses.flexCol}>
                    <Box className={cssClasses.headerTitle}>
                      {/* Update Unit Status */}
                      Hold Unit
                    </Box>{' '}
                  </Box>
                  <Box
                    ml={'auto'}
                    mt={1}
                    onClick={handleClose}
                    style={{ cursor: 'pointer' }}
                  >
                    <Close width={'1.2rem'} height={'1.2rem'} />
                  </Box>
                </Box>
              </Box>

              <Box>
                <Box margin={'1.5rem 3.2rem'}>
                  <Box className={cssClasses.PhoneNumberTitle}>
                    Hold Unit of{' '}
                    {UnitData[0]?.wingId?.displayName
                      ? UnitData[0]?.wingId?.displayName
                      : UnitData[0]?.wingId?.wingName
                        ? UnitData[0]?.wingId?.wingName
                        : '-'}
                    {/* {UnitData[0]?.wingId?.wingName
                      ? UnitData[0]?.wingId?.wingName
                      : "-"} */}
                    -{UnitData[0]?.unitNo ? UnitData[0]?.unitNo : '-'} for{' '}
                    {SelectedLeadName}
                    (VJ{SelectedLeadDisplayId})
                  </Box>
                  {globalLead === false && (
                    // ! vedashree changes
                    <Box width={'75%'}>
                      {/* <Box width={"25rem"}> */}
                      {TokenList?.length === 1 && (
                        <>
                          <Box className={cssClasses.SubHeader} mt={1.6}>
                            Token Name
                          </Box>
                          <Box mt={1.6} mb={2}>
                            <Box
                              className={cssClasses.outerBox}
                              width={'fit-Content'}
                            >
                              <p className={cssClasses.readFieldBox}>
                                {TokenList[0].eventTokenId?.tokenId?.name}(
                                {TokenList[0]?.tokenNumber})
                              </p>
                            </Box>
                          </Box>
                        </>
                      )}

                      {TokenList?.length > 1 && (
                        <>
                          <Box className={cssClasses.SubHeader} mt={1.6}>
                            Select Tokens
                          </Box>
                          <Box mt={1.6} mb={2}>
                            <DropDown
                              placeHolder={'Select'}
                              list={TokenList.map((element, _id) => {
                                return {
                                  label: `${element?.eventTokenId?.tokenId?.name}(${element?.tokenNumber})`,
                                  value: element?.paymentId,
                                };
                              })}
                              selectedValue={TokenData.token}
                              onChangeSelect={(value) => {
                                setTokenData((pre) => {
                                  pre.token = value;
                                  console.log('value', value);
                                  return { ...pre };
                                });

                                if (TokenData.token !== '') {
                                  TokenHelperText.token = '';
                                } else {
                                  TokenHelperText.token = 'Please select Token';
                                }
                              }}
                              style={{
                                background: '#F2F4F7',
                                selectedColor: '#667085',
                              }}
                              helperText={TokenHelperText.token}
                            />
                          </Box>
                        </>
                      )}
                    </Box>
                  )}
                  {/* <Box className={cssClasses.SubHeader} mt={1.6}>
                Status
              </Box> */}
                  {/* <Box>
                <CustomRadio
                  value={unitStatus}
                  optionList={UnitStatusType}
                  onChangeValue={setUnitStatus}
                />
              </Box> */}
                  {/* ! Sarita Added DropDown for payment Plan */}
                  {listOfProjectPaymentPlan.length > 0 && (
                    <Box className={cssClasses.wrapperDropDown}>
                      <div className={cssClasses.SubHeader}>
                        Select Payment Plan
                      </div>
                      <div style={{ width: '60%' }}>
                        <DropDown
                          list={listOfProjectPaymentPlan.map((element, id) => {
                            return {
                              label: element?.title,
                              value: element?.title,
                            };
                          })}
                          selectedValue={selectedProjectPaymentPlanId}
                          onChangeSelect={(value) => {
                            setSelectedProjectPaymentPlanId(value);
                            let selectedProjectPricing =
                              listOfProjectPaymentPlan.filter(
                                (el) => value === el.paymentPlanId.key
                              );
                            setSelectedProjectPaymentPlan(
                              selectedProjectPricing[0]
                            );
                          }}
                          placeHolder={'Select Payment Plan'}
                          style={{
                            background: '#F2F4F7',
                            color: 'rgb(102, 112, 133)',
                          }}
                        />
                      </div>
                    </Box>
                  )}
                </Box>
                <Box className={cssClasses.FooterDiv}>
                  <Box className={cssClasses.flexRow}>
                    <Box width={'fit-Content'} ml={'auto'}>
                      <Button
                        style={{
                          fontSize: '1.4rem',
                          lineHeight: '2rem',
                          color: '#344054',
                          backgroundColor: '#FFFFFF',
                          borderRadius: '0.8rem',
                        }}
                        padding={'0.85rem 2.6rem'}
                        btnName={'Exit'}
                        clicked={handleClose}
                      />
                    </Box>
                    {TokenList.length > 0 ? (
                      <>
                        {getAlotEventLead()?.oldAllotmentData
                          ? Object.keys(getAlotEventLead()?.oldAllotmentData)
                            .length === 0 ||
                          Object.keys(getAlotEventLead()?.oldAllotmentData)
                            .length === null
                          : true && (
                            <Box width={'fit-Content'}>
                              <Button
                                style={{
                                  color: '#fff',
                                  backgroundColor: '#1570EF',
                                  fontSize: '1.4rem',
                                  lineHeight: '2rem',
                                  fontFamily: 'Roboto-Regular',
                                }}
                                //  disable={unitStatus === ''}
                                padding={'0.65rem 2.5rem'}
                                btnName={'Hold & Exit'}
                                clicked={() => OnSubmit('Hold & Exit')}
                              />
                            </Box>
                          )}

                        {PayNowButton === true && (
                          <Box width={'fit-Content'}>
                            <Button
                              style={{
                                color: '#fff',
                                backgroundColor: '#1570EF',
                                fontSize: '1.4rem',
                                lineHeight: '2rem',
                                fontFamily: 'Roboto-Regular',
                              }}
                              // disable={unitStatus === ''}
                              padding={'0.65rem 2.5rem'}
                              btnName={'Hold & Continue'}
                              clicked={() => OnSubmitWrapper('Hold & Continue')}
                            />
                          </Box>
                        )}
                      </>
                    ) : (
                      // ! because it is priority pass & inventory type does not match
                      <p>Tokens not available!</p>
                    )}
                  </Box>
                </Box>
              </Box>
            </Box>
          </Modal>
        </>
      )}

      {isLoading && (
        <LoaderWithMsg isLoading={isLoading} loaderMsg={loaderMsg} />
      )}

      {openPaymentModal === true && (
        <div style={{ height: '100%', padding: '3rem' }}>
          <PaymentModal
            allotment={AllotmentIdData[0]}
            desk={
              PreSelectedLead
                ? 'preselectPaymentModes'
                : 'salesManagerDeskPaymentModes'
            }
            setOpenPaymentModal={setOpenPaymentModal}
            showBackToFastBooking={fastBooking}
          />
        </div>
      )}
    </>
  );
}

export default EventPayment;
